import me, { useLayoutEffect as oi, useEffect as ii, useMemo as Ee, useContext as at, useReducer as jn, useRef as $e, useDebugValue as ai, createContext as ui, useCallback as si } from "react";
import { unstable_batchedUpdates as ci } from "react-dom";
var ur = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Tr(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Xr = { exports: {} }, Mr = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Dr, Bt;
function ut() {
  if (Bt)
    return Dr;
  Bt = 1;
  var r = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, e = Object.prototype.propertyIsEnumerable;
  function n(u) {
    if (u == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(u);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var u = new String("abc");
      if (u[5] = "de", Object.getOwnPropertyNames(u)[0] === "5")
        return !1;
      for (var c = {}, v = 0; v < 10; v++)
        c["_" + String.fromCharCode(v)] = v;
      var f = Object.getOwnPropertyNames(c).map(function(y) {
        return c[y];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(y) {
        p[y] = y;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Dr = i() ? Object.assign : function(u, c) {
    for (var v, f = n(u), p, y = 1; y < arguments.length; y++) {
      v = Object(arguments[y]);
      for (var o in v)
        t.call(v, o) && (f[o] = v[o]);
      if (r) {
        p = r(v);
        for (var a = 0; a < p.length; a++)
          e.call(v, p[a]) && (f[p[a]] = v[p[a]]);
      }
    }
    return f;
  }, Dr;
}
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wt;
function fi() {
  return Wt || (Wt = 1, function(r) {
    process.env.NODE_ENV !== "production" && function() {
      var t = me, e = ut(), n = 60103, i = 60106;
      r.Fragment = 60107;
      var u = 60108, c = 60114, v = 60109, f = 60110, p = 60112, y = 60113, o = 60120, a = 60115, s = 60116, d = 60121, h = 60122, m = 60117, l = 60129, g = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var S = Symbol.for;
        n = S("react.element"), i = S("react.portal"), r.Fragment = S("react.fragment"), u = S("react.strict_mode"), c = S("react.profiler"), v = S("react.provider"), f = S("react.context"), p = S("react.forward_ref"), y = S("react.suspense"), o = S("react.suspense_list"), a = S("react.memo"), s = S("react.lazy"), d = S("react.block"), h = S("react.server.block"), m = S("react.fundamental"), S("react.scope"), S("react.opaque.id"), l = S("react.debug_trace_mode"), S("react.offscreen"), g = S("react.legacy_hidden");
      }
      var A = typeof Symbol == "function" && Symbol.iterator, w = "@@iterator";
      function X(_) {
        if (_ === null || typeof _ != "object")
          return null;
        var E = A && _[A] || _[w];
        return typeof E == "function" ? E : null;
      }
      var q = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function B(_) {
        {
          for (var E = arguments.length, R = new Array(E > 1 ? E - 1 : 0), D = 1; D < E; D++)
            R[D - 1] = arguments[D];
          N("error", _, R);
        }
      }
      function N(_, E, R) {
        {
          var D = q.ReactDebugCurrentFrame, J = D.getStackAddendum();
          J !== "" && (E += "%s", R = R.concat([J]));
          var z = R.map(function(U) {
            return "" + U;
          });
          z.unshift("Warning: " + E), Function.prototype.apply.call(console[_], console, z);
        }
      }
      var ce = !1;
      function se(_) {
        return !!(typeof _ == "string" || typeof _ == "function" || _ === r.Fragment || _ === c || _ === l || _ === u || _ === y || _ === o || _ === g || ce || typeof _ == "object" && _ !== null && (_.$$typeof === s || _.$$typeof === a || _.$$typeof === v || _.$$typeof === f || _.$$typeof === p || _.$$typeof === m || _.$$typeof === d || _[0] === h));
      }
      function le(_, E, R) {
        var D = E.displayName || E.name || "";
        return _.displayName || (D !== "" ? R + "(" + D + ")" : R);
      }
      function O(_) {
        return _.displayName || "Context";
      }
      function H(_) {
        if (_ == null)
          return null;
        if (typeof _.tag == "number" && B("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof _ == "function")
          return _.displayName || _.name || null;
        if (typeof _ == "string")
          return _;
        switch (_) {
          case r.Fragment:
            return "Fragment";
          case i:
            return "Portal";
          case c:
            return "Profiler";
          case u:
            return "StrictMode";
          case y:
            return "Suspense";
          case o:
            return "SuspenseList";
        }
        if (typeof _ == "object")
          switch (_.$$typeof) {
            case f:
              var E = _;
              return O(E) + ".Consumer";
            case v:
              var R = _;
              return O(R._context) + ".Provider";
            case p:
              return le(_, _.render, "ForwardRef");
            case a:
              return H(_.type);
            case d:
              return H(_._render);
            case s: {
              var D = _, J = D._payload, z = D._init;
              try {
                return H(z(J));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var oe = 0, te, K, de, fe, b, P, $;
      function k() {
      }
      k.__reactDisabledLog = !0;
      function C() {
        {
          if (oe === 0) {
            te = console.log, K = console.info, de = console.warn, fe = console.error, b = console.group, P = console.groupCollapsed, $ = console.groupEnd;
            var _ = {
              configurable: !0,
              enumerable: !0,
              value: k,
              writable: !0
            };
            Object.defineProperties(console, {
              info: _,
              log: _,
              warn: _,
              error: _,
              group: _,
              groupCollapsed: _,
              groupEnd: _
            });
          }
          oe++;
        }
      }
      function V() {
        {
          if (oe--, oe === 0) {
            var _ = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: e({}, _, {
                value: te
              }),
              info: e({}, _, {
                value: K
              }),
              warn: e({}, _, {
                value: de
              }),
              error: e({}, _, {
                value: fe
              }),
              group: e({}, _, {
                value: b
              }),
              groupCollapsed: e({}, _, {
                value: P
              }),
              groupEnd: e({}, _, {
                value: $
              })
            });
          }
          oe < 0 && B("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var I = q.ReactCurrentDispatcher, M;
      function j(_, E, R) {
        {
          if (M === void 0)
            try {
              throw Error();
            } catch (J) {
              var D = J.stack.trim().match(/\n( *(at )?)/);
              M = D && D[1] || "";
            }
          return `
` + M + _;
        }
      }
      var F = !1, L;
      {
        var x = typeof WeakMap == "function" ? WeakMap : Map;
        L = new x();
      }
      function T(_, E) {
        if (!_ || F)
          return "";
        {
          var R = L.get(_);
          if (R !== void 0)
            return R;
        }
        var D;
        F = !0;
        var J = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var z;
        z = I.current, I.current = null, C();
        try {
          if (E) {
            var U = function() {
              throw Error();
            };
            if (Object.defineProperty(U.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(U, []);
              } catch (Ie) {
                D = Ie;
              }
              Reflect.construct(_, [], U);
            } else {
              try {
                U.call();
              } catch (Ie) {
                D = Ie;
              }
              _.call(U.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Ie) {
              D = Ie;
            }
            _();
          }
        } catch (Ie) {
          if (Ie && D && typeof Ie.stack == "string") {
            for (var Y = Ie.stack.split(`
`), pe = D.stack.split(`
`), ne = Y.length - 1, ae = pe.length - 1; ne >= 1 && ae >= 0 && Y[ne] !== pe[ae]; )
              ae--;
            for (; ne >= 1 && ae >= 0; ne--, ae--)
              if (Y[ne] !== pe[ae]) {
                if (ne !== 1 || ae !== 1)
                  do
                    if (ne--, ae--, ae < 0 || Y[ne] !== pe[ae]) {
                      var Re = `
` + Y[ne].replace(" at new ", " at ");
                      return typeof _ == "function" && L.set(_, Re), Re;
                    }
                  while (ne >= 1 && ae >= 0);
                break;
              }
          }
        } finally {
          F = !1, I.current = z, V(), Error.prepareStackTrace = J;
        }
        var Ke = _ ? _.displayName || _.name : "", Ut = Ke ? j(Ke) : "";
        return typeof _ == "function" && L.set(_, Ut), Ut;
      }
      function ie(_, E, R) {
        return T(_, !1);
      }
      function _e(_) {
        var E = _.prototype;
        return !!(E && E.isReactComponent);
      }
      function Pe(_, E, R) {
        if (_ == null)
          return "";
        if (typeof _ == "function")
          return T(_, _e(_));
        if (typeof _ == "string")
          return j(_);
        switch (_) {
          case y:
            return j("Suspense");
          case o:
            return j("SuspenseList");
        }
        if (typeof _ == "object")
          switch (_.$$typeof) {
            case p:
              return ie(_.render);
            case a:
              return Pe(_.type, E, R);
            case d:
              return ie(_._render);
            case s: {
              var D = _, J = D._payload, z = D._init;
              try {
                return Pe(z(J), E, R);
              } catch {
              }
            }
          }
        return "";
      }
      var ar = {}, We = q.ReactDebugCurrentFrame;
      function Oe(_) {
        if (_) {
          var E = _._owner, R = Pe(_.type, _._source, E ? E.type : null);
          We.setExtraStackFrame(R);
        } else
          We.setExtraStackFrame(null);
      }
      function _r(_, E, R, D, J) {
        {
          var z = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var U in _)
            if (z(_, U)) {
              var Y = void 0;
              try {
                if (typeof _[U] != "function") {
                  var pe = Error((D || "React class") + ": " + R + " type `" + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof _[U] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw pe.name = "Invariant Violation", pe;
                }
                Y = _[U](E, U, D, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ne) {
                Y = ne;
              }
              Y && !(Y instanceof Error) && (Oe(J), B("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", D || "React class", R, U, typeof Y), Oe(null)), Y instanceof Error && !(Y.message in ar) && (ar[Y.message] = !0, Oe(J), B("Failed %s type: %s", R, Y.message), Oe(null));
            }
        }
      }
      var xe = q.ReactCurrentOwner, Fe = Object.prototype.hasOwnProperty, xr = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, ke, Ge, Rr;
      Rr = {};
      function qo(_) {
        if (Fe.call(_, "ref")) {
          var E = Object.getOwnPropertyDescriptor(_, "ref").get;
          if (E && E.isReactWarning)
            return !1;
        }
        return _.ref !== void 0;
      }
      function Uo(_) {
        if (Fe.call(_, "key")) {
          var E = Object.getOwnPropertyDescriptor(_, "key").get;
          if (E && E.isReactWarning)
            return !1;
        }
        return _.key !== void 0;
      }
      function Bo(_, E) {
        if (typeof _.ref == "string" && xe.current && E && xe.current.stateNode !== E) {
          var R = H(xe.current.type);
          Rr[R] || (B('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H(xe.current.type), _.ref), Rr[R] = !0);
        }
      }
      function Wo(_, E) {
        {
          var R = function() {
            ke || (ke = !0, B("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
          };
          R.isReactWarning = !0, Object.defineProperty(_, "key", {
            get: R,
            configurable: !0
          });
        }
      }
      function Go(_, E) {
        {
          var R = function() {
            Ge || (Ge = !0, B("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
          };
          R.isReactWarning = !0, Object.defineProperty(_, "ref", {
            get: R,
            configurable: !0
          });
        }
      }
      var Xo = function(_, E, R, D, J, z, U) {
        var Y = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: _,
          key: E,
          ref: R,
          props: U,
          // Record the component responsible for creating this element.
          _owner: z
        };
        return Y._store = {}, Object.defineProperty(Y._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Y, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: D
        }), Object.defineProperty(Y, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: J
        }), Object.freeze && (Object.freeze(Y.props), Object.freeze(Y)), Y;
      };
      function Ko(_, E, R, D, J) {
        {
          var z, U = {}, Y = null, pe = null;
          R !== void 0 && (Y = "" + R), Uo(E) && (Y = "" + E.key), qo(E) && (pe = E.ref, Bo(E, J));
          for (z in E)
            Fe.call(E, z) && !xr.hasOwnProperty(z) && (U[z] = E[z]);
          if (_ && _.defaultProps) {
            var ne = _.defaultProps;
            for (z in ne)
              U[z] === void 0 && (U[z] = ne[z]);
          }
          if (Y || pe) {
            var ae = typeof _ == "function" ? _.displayName || _.name || "Unknown" : _;
            Y && Wo(U, ae), pe && Go(U, ae);
          }
          return Xo(_, Y, pe, J, D, xe.current, U);
        }
      }
      var Ir = q.ReactCurrentOwner, Lt = q.ReactDebugCurrentFrame;
      function Xe(_) {
        if (_) {
          var E = _._owner, R = Pe(_.type, _._source, E ? E.type : null);
          Lt.setExtraStackFrame(R);
        } else
          Lt.setExtraStackFrame(null);
      }
      var Cr;
      Cr = !1;
      function kr(_) {
        return typeof _ == "object" && _ !== null && _.$$typeof === n;
      }
      function Ft() {
        {
          if (Ir.current) {
            var _ = H(Ir.current.type);
            if (_)
              return `

Check the render method of \`` + _ + "`.";
          }
          return "";
        }
      }
      function Qo(_) {
        {
          if (_ !== void 0) {
            var E = _.fileName.replace(/^.*[\\\/]/, ""), R = _.lineNumber;
            return `

Check your code at ` + E + ":" + R + ".";
          }
          return "";
        }
      }
      var Vt = {};
      function Zo(_) {
        {
          var E = Ft();
          if (!E) {
            var R = typeof _ == "string" ? _ : _.displayName || _.name;
            R && (E = `

Check the top-level render call using <` + R + ">.");
          }
          return E;
        }
      }
      function Ht(_, E) {
        {
          if (!_._store || _._store.validated || _.key != null)
            return;
          _._store.validated = !0;
          var R = Zo(E);
          if (Vt[R])
            return;
          Vt[R] = !0;
          var D = "";
          _ && _._owner && _._owner !== Ir.current && (D = " It was passed a child from " + H(_._owner.type) + "."), Xe(_), B('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, D), Xe(null);
        }
      }
      function Yt(_, E) {
        {
          if (typeof _ != "object")
            return;
          if (Array.isArray(_))
            for (var R = 0; R < _.length; R++) {
              var D = _[R];
              kr(D) && Ht(D, E);
            }
          else if (kr(_))
            _._store && (_._store.validated = !0);
          else if (_) {
            var J = X(_);
            if (typeof J == "function" && J !== _.entries)
              for (var z = J.call(_), U; !(U = z.next()).done; )
                kr(U.value) && Ht(U.value, E);
          }
        }
      }
      function Jo(_) {
        {
          var E = _.type;
          if (E == null || typeof E == "string")
            return;
          var R;
          if (typeof E == "function")
            R = E.propTypes;
          else if (typeof E == "object" && (E.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          E.$$typeof === a))
            R = E.propTypes;
          else
            return;
          if (R) {
            var D = H(E);
            _r(R, _.props, "prop", D, _);
          } else if (E.PropTypes !== void 0 && !Cr) {
            Cr = !0;
            var J = H(E);
            B("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", J || "Unknown");
          }
          typeof E.getDefaultProps == "function" && !E.getDefaultProps.isReactClassApproved && B("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function zo(_) {
        {
          for (var E = Object.keys(_.props), R = 0; R < E.length; R++) {
            var D = E[R];
            if (D !== "children" && D !== "key") {
              Xe(_), B("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", D), Xe(null);
              break;
            }
          }
          _.ref !== null && (Xe(_), B("Invalid attribute `ref` supplied to `React.Fragment`."), Xe(null));
        }
      }
      function qt(_, E, R, D, J, z) {
        {
          var U = se(_);
          if (!U) {
            var Y = "";
            (_ === void 0 || typeof _ == "object" && _ !== null && Object.keys(_).length === 0) && (Y += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var pe = Qo(J);
            pe ? Y += pe : Y += Ft();
            var ne;
            _ === null ? ne = "null" : Array.isArray(_) ? ne = "array" : _ !== void 0 && _.$$typeof === n ? (ne = "<" + (H(_.type) || "Unknown") + " />", Y = " Did you accidentally export a JSX literal instead of a component?") : ne = typeof _, B("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ne, Y);
          }
          var ae = Ko(_, E, R, J, z);
          if (ae == null)
            return ae;
          if (U) {
            var Re = E.children;
            if (Re !== void 0)
              if (D)
                if (Array.isArray(Re)) {
                  for (var Ke = 0; Ke < Re.length; Ke++)
                    Yt(Re[Ke], _);
                  Object.freeze && Object.freeze(Re);
                } else
                  B("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Yt(Re, _);
          }
          return _ === r.Fragment ? zo(ae) : Jo(ae), ae;
        }
      }
      function ei(_, E, R) {
        return qt(_, E, R, !0);
      }
      function ri(_, E, R) {
        return qt(_, E, R, !1);
      }
      var ti = ri, ni = ei;
      r.jsx = ti, r.jsxs = ni;
    }();
  }(Mr)), Mr;
}
var Qe = {};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gt;
function li() {
  if (Gt)
    return Qe;
  Gt = 1, ut();
  var r = me, t = 60103;
  if (Qe.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var e = Symbol.for;
    t = e("react.element"), Qe.Fragment = e("react.fragment");
  }
  var n = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = Object.prototype.hasOwnProperty, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(v, f, p) {
    var y, o = {}, a = null, s = null;
    p !== void 0 && (a = "" + p), f.key !== void 0 && (a = "" + f.key), f.ref !== void 0 && (s = f.ref);
    for (y in f)
      i.call(f, y) && !u.hasOwnProperty(y) && (o[y] = f[y]);
    if (v && v.defaultProps)
      for (y in f = v.defaultProps, f)
        o[y] === void 0 && (o[y] = f[y]);
    return { $$typeof: t, type: v, key: a, ref: s, props: o, _owner: n.current };
  }
  return Qe.jsx = c, Qe.jsxs = c, Qe;
}
process.env.NODE_ENV === "production" ? Xr.exports = li() : Xr.exports = fi();
var Ce = Xr.exports, Kr = { exports: {} }, $r, Xt;
function st() {
  if (Xt)
    return $r;
  Xt = 1;
  var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return $r = r, $r;
}
var Nr, Kt;
function di() {
  if (Kt)
    return Nr;
  Kt = 1;
  var r = st();
  function t() {
  }
  function e() {
  }
  return e.resetWarningCache = t, Nr = function() {
    function n(c, v, f, p, y, o) {
      if (o !== r) {
        var a = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw a.name = "Invariant Violation", a;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var u = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: e,
      resetWarningCache: t
    };
    return u.PropTypes = u, u;
  }, Nr;
}
var Qr = { exports: {} }, W = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qt;
function pi() {
  return Qt || (Qt = 1, process.env.NODE_ENV !== "production" && function() {
    var r = typeof Symbol == "function" && Symbol.for, t = r ? Symbol.for("react.element") : 60103, e = r ? Symbol.for("react.portal") : 60106, n = r ? Symbol.for("react.fragment") : 60107, i = r ? Symbol.for("react.strict_mode") : 60108, u = r ? Symbol.for("react.profiler") : 60114, c = r ? Symbol.for("react.provider") : 60109, v = r ? Symbol.for("react.context") : 60110, f = r ? Symbol.for("react.async_mode") : 60111, p = r ? Symbol.for("react.concurrent_mode") : 60111, y = r ? Symbol.for("react.forward_ref") : 60112, o = r ? Symbol.for("react.suspense") : 60113, a = r ? Symbol.for("react.suspense_list") : 60120, s = r ? Symbol.for("react.memo") : 60115, d = r ? Symbol.for("react.lazy") : 60116, h = r ? Symbol.for("react.block") : 60121, m = r ? Symbol.for("react.fundamental") : 60117, l = r ? Symbol.for("react.responder") : 60118, g = r ? Symbol.for("react.scope") : 60119;
    function S(T) {
      return typeof T == "string" || typeof T == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      T === n || T === p || T === u || T === i || T === o || T === a || typeof T == "object" && T !== null && (T.$$typeof === d || T.$$typeof === s || T.$$typeof === c || T.$$typeof === v || T.$$typeof === y || T.$$typeof === m || T.$$typeof === l || T.$$typeof === g || T.$$typeof === h);
    }
    function A(T) {
      if (typeof T == "object" && T !== null) {
        var ie = T.$$typeof;
        switch (ie) {
          case t:
            var _e = T.type;
            switch (_e) {
              case f:
              case p:
              case n:
              case u:
              case i:
              case o:
                return _e;
              default:
                var Pe = _e && _e.$$typeof;
                switch (Pe) {
                  case v:
                  case y:
                  case d:
                  case s:
                  case c:
                    return Pe;
                  default:
                    return ie;
                }
            }
          case e:
            return ie;
        }
      }
    }
    var w = f, X = p, q = v, B = c, N = t, ce = y, se = n, le = d, O = s, H = e, oe = u, te = i, K = o, de = !1;
    function fe(T) {
      return de || (de = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), b(T) || A(T) === f;
    }
    function b(T) {
      return A(T) === p;
    }
    function P(T) {
      return A(T) === v;
    }
    function $(T) {
      return A(T) === c;
    }
    function k(T) {
      return typeof T == "object" && T !== null && T.$$typeof === t;
    }
    function C(T) {
      return A(T) === y;
    }
    function V(T) {
      return A(T) === n;
    }
    function I(T) {
      return A(T) === d;
    }
    function M(T) {
      return A(T) === s;
    }
    function j(T) {
      return A(T) === e;
    }
    function F(T) {
      return A(T) === u;
    }
    function L(T) {
      return A(T) === i;
    }
    function x(T) {
      return A(T) === o;
    }
    W.AsyncMode = w, W.ConcurrentMode = X, W.ContextConsumer = q, W.ContextProvider = B, W.Element = N, W.ForwardRef = ce, W.Fragment = se, W.Lazy = le, W.Memo = O, W.Portal = H, W.Profiler = oe, W.StrictMode = te, W.Suspense = K, W.isAsyncMode = fe, W.isConcurrentMode = b, W.isContextConsumer = P, W.isContextProvider = $, W.isElement = k, W.isForwardRef = C, W.isFragment = V, W.isLazy = I, W.isMemo = M, W.isPortal = j, W.isProfiler = F, W.isStrictMode = L, W.isSuspense = x, W.isValidElementType = S, W.typeOf = A;
  }()), W;
}
var G = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zt;
function vi() {
  if (Zt)
    return G;
  Zt = 1;
  var r = typeof Symbol == "function" && Symbol.for, t = r ? Symbol.for("react.element") : 60103, e = r ? Symbol.for("react.portal") : 60106, n = r ? Symbol.for("react.fragment") : 60107, i = r ? Symbol.for("react.strict_mode") : 60108, u = r ? Symbol.for("react.profiler") : 60114, c = r ? Symbol.for("react.provider") : 60109, v = r ? Symbol.for("react.context") : 60110, f = r ? Symbol.for("react.async_mode") : 60111, p = r ? Symbol.for("react.concurrent_mode") : 60111, y = r ? Symbol.for("react.forward_ref") : 60112, o = r ? Symbol.for("react.suspense") : 60113, a = r ? Symbol.for("react.suspense_list") : 60120, s = r ? Symbol.for("react.memo") : 60115, d = r ? Symbol.for("react.lazy") : 60116, h = r ? Symbol.for("react.block") : 60121, m = r ? Symbol.for("react.fundamental") : 60117, l = r ? Symbol.for("react.responder") : 60118, g = r ? Symbol.for("react.scope") : 60119;
  function S(w) {
    if (typeof w == "object" && w !== null) {
      var X = w.$$typeof;
      switch (X) {
        case t:
          switch (w = w.type, w) {
            case f:
            case p:
            case n:
            case u:
            case i:
            case o:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case v:
                case y:
                case d:
                case s:
                case c:
                  return w;
                default:
                  return X;
              }
          }
        case e:
          return X;
      }
    }
  }
  function A(w) {
    return S(w) === p;
  }
  return G.AsyncMode = f, G.ConcurrentMode = p, G.ContextConsumer = v, G.ContextProvider = c, G.Element = t, G.ForwardRef = y, G.Fragment = n, G.Lazy = d, G.Memo = s, G.Portal = e, G.Profiler = u, G.StrictMode = i, G.Suspense = o, G.isAsyncMode = function(w) {
    return A(w) || S(w) === f;
  }, G.isConcurrentMode = A, G.isContextConsumer = function(w) {
    return S(w) === v;
  }, G.isContextProvider = function(w) {
    return S(w) === c;
  }, G.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, G.isForwardRef = function(w) {
    return S(w) === y;
  }, G.isFragment = function(w) {
    return S(w) === n;
  }, G.isLazy = function(w) {
    return S(w) === d;
  }, G.isMemo = function(w) {
    return S(w) === s;
  }, G.isPortal = function(w) {
    return S(w) === e;
  }, G.isProfiler = function(w) {
    return S(w) === u;
  }, G.isStrictMode = function(w) {
    return S(w) === i;
  }, G.isSuspense = function(w) {
    return S(w) === o;
  }, G.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === n || w === p || w === u || w === i || w === o || w === a || typeof w == "object" && w !== null && (w.$$typeof === d || w.$$typeof === s || w.$$typeof === c || w.$$typeof === v || w.$$typeof === y || w.$$typeof === m || w.$$typeof === l || w.$$typeof === g || w.$$typeof === h);
  }, G.typeOf = S, G;
}
process.env.NODE_ENV === "production" ? Qr.exports = vi() : Qr.exports = pi();
var ct = Qr.exports, jr, Jt;
function Ln() {
  return Jt || (Jt = 1, jr = Function.call.bind(Object.prototype.hasOwnProperty)), jr;
}
var Lr, zt;
function _i() {
  if (zt)
    return Lr;
  zt = 1;
  var r = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = st(), e = {}, n = Ln();
    r = function(u) {
      var c = "Warning: " + u;
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
  }
  function i(u, c, v, f, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var y in u)
        if (n(u, y)) {
          var o;
          try {
            if (typeof u[y] != "function") {
              var a = Error(
                (f || "React class") + ": " + v + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof u[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw a.name = "Invariant Violation", a;
            }
            o = u[y](c, y, f, v, null, t);
          } catch (d) {
            o = d;
          }
          if (o && !(o instanceof Error) && r(
            (f || "React class") + ": type specification of " + v + " `" + y + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof o + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), o instanceof Error && !(o.message in e)) {
            e[o.message] = !0;
            var s = p ? p() : "";
            r(
              "Failed " + v + " type: " + o.message + (s ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (e = {});
  }, Lr = i, Lr;
}
var Fr, en;
function hi() {
  if (en)
    return Fr;
  en = 1;
  var r = ct, t = ut(), e = st(), n = Ln(), i = _i(), u = function() {
  };
  process.env.NODE_ENV !== "production" && (u = function(v) {
    var f = "Warning: " + v;
    typeof console < "u" && console.error(f);
    try {
      throw new Error(f);
    } catch {
    }
  });
  function c() {
    return null;
  }
  return Fr = function(v, f) {
    var p = typeof Symbol == "function" && Symbol.iterator, y = "@@iterator";
    function o(b) {
      var P = b && (p && b[p] || b[y]);
      if (typeof P == "function")
        return P;
    }
    var a = "<<anonymous>>", s = {
      array: l("array"),
      bigint: l("bigint"),
      bool: l("boolean"),
      func: l("function"),
      number: l("number"),
      object: l("object"),
      string: l("string"),
      symbol: l("symbol"),
      any: g(),
      arrayOf: S,
      element: A(),
      elementType: w(),
      instanceOf: X,
      node: ce(),
      objectOf: B,
      oneOf: q,
      oneOfType: N,
      shape: le,
      exact: O
    };
    function d(b, P) {
      return b === P ? b !== 0 || 1 / b === 1 / P : b !== b && P !== P;
    }
    function h(b, P) {
      this.message = b, this.data = P && typeof P == "object" ? P : {}, this.stack = "";
    }
    h.prototype = Error.prototype;
    function m(b) {
      if (process.env.NODE_ENV !== "production")
        var P = {}, $ = 0;
      function k(V, I, M, j, F, L, x) {
        if (j = j || a, L = L || M, x !== e) {
          if (f) {
            var T = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw T.name = "Invariant Violation", T;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ie = j + ":" + M;
            !P[ie] && // Avoid spamming the console because they are often not actionable except for lib authors
            $ < 3 && (u(
              "You are manually calling a React.PropTypes validation function for the `" + L + "` prop on `" + j + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), P[ie] = !0, $++);
          }
        }
        return I[M] == null ? V ? I[M] === null ? new h("The " + F + " `" + L + "` is marked as required " + ("in `" + j + "`, but its value is `null`.")) : new h("The " + F + " `" + L + "` is marked as required in " + ("`" + j + "`, but its value is `undefined`.")) : null : b(I, M, j, F, L);
      }
      var C = k.bind(null, !1);
      return C.isRequired = k.bind(null, !0), C;
    }
    function l(b) {
      function P($, k, C, V, I, M) {
        var j = $[k], F = te(j);
        if (F !== b) {
          var L = K(j);
          return new h(
            "Invalid " + V + " `" + I + "` of type " + ("`" + L + "` supplied to `" + C + "`, expected ") + ("`" + b + "`."),
            { expectedType: b }
          );
        }
        return null;
      }
      return m(P);
    }
    function g() {
      return m(c);
    }
    function S(b) {
      function P($, k, C, V, I) {
        if (typeof b != "function")
          return new h("Property `" + I + "` of component `" + C + "` has invalid PropType notation inside arrayOf.");
        var M = $[k];
        if (!Array.isArray(M)) {
          var j = te(M);
          return new h("Invalid " + V + " `" + I + "` of type " + ("`" + j + "` supplied to `" + C + "`, expected an array."));
        }
        for (var F = 0; F < M.length; F++) {
          var L = b(M, F, C, V, I + "[" + F + "]", e);
          if (L instanceof Error)
            return L;
        }
        return null;
      }
      return m(P);
    }
    function A() {
      function b(P, $, k, C, V) {
        var I = P[$];
        if (!v(I)) {
          var M = te(I);
          return new h("Invalid " + C + " `" + V + "` of type " + ("`" + M + "` supplied to `" + k + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(b);
    }
    function w() {
      function b(P, $, k, C, V) {
        var I = P[$];
        if (!r.isValidElementType(I)) {
          var M = te(I);
          return new h("Invalid " + C + " `" + V + "` of type " + ("`" + M + "` supplied to `" + k + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(b);
    }
    function X(b) {
      function P($, k, C, V, I) {
        if (!($[k] instanceof b)) {
          var M = b.name || a, j = fe($[k]);
          return new h("Invalid " + V + " `" + I + "` of type " + ("`" + j + "` supplied to `" + C + "`, expected ") + ("instance of `" + M + "`."));
        }
        return null;
      }
      return m(P);
    }
    function q(b) {
      if (!Array.isArray(b))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? u(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : u("Invalid argument supplied to oneOf, expected an array.")), c;
      function P($, k, C, V, I) {
        for (var M = $[k], j = 0; j < b.length; j++)
          if (d(M, b[j]))
            return null;
        var F = JSON.stringify(b, function(x, T) {
          var ie = K(T);
          return ie === "symbol" ? String(T) : T;
        });
        return new h("Invalid " + V + " `" + I + "` of value `" + String(M) + "` " + ("supplied to `" + C + "`, expected one of " + F + "."));
      }
      return m(P);
    }
    function B(b) {
      function P($, k, C, V, I) {
        if (typeof b != "function")
          return new h("Property `" + I + "` of component `" + C + "` has invalid PropType notation inside objectOf.");
        var M = $[k], j = te(M);
        if (j !== "object")
          return new h("Invalid " + V + " `" + I + "` of type " + ("`" + j + "` supplied to `" + C + "`, expected an object."));
        for (var F in M)
          if (n(M, F)) {
            var L = b(M, F, C, V, I + "." + F, e);
            if (L instanceof Error)
              return L;
          }
        return null;
      }
      return m(P);
    }
    function N(b) {
      if (!Array.isArray(b))
        return process.env.NODE_ENV !== "production" && u("Invalid argument supplied to oneOfType, expected an instance of array."), c;
      for (var P = 0; P < b.length; P++) {
        var $ = b[P];
        if (typeof $ != "function")
          return u(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + de($) + " at index " + P + "."
          ), c;
      }
      function k(C, V, I, M, j) {
        for (var F = [], L = 0; L < b.length; L++) {
          var x = b[L], T = x(C, V, I, M, j, e);
          if (T == null)
            return null;
          T.data && n(T.data, "expectedType") && F.push(T.data.expectedType);
        }
        var ie = F.length > 0 ? ", expected one of type [" + F.join(", ") + "]" : "";
        return new h("Invalid " + M + " `" + j + "` supplied to " + ("`" + I + "`" + ie + "."));
      }
      return m(k);
    }
    function ce() {
      function b(P, $, k, C, V) {
        return H(P[$]) ? null : new h("Invalid " + C + " `" + V + "` supplied to " + ("`" + k + "`, expected a ReactNode."));
      }
      return m(b);
    }
    function se(b, P, $, k, C) {
      return new h(
        (b || "React class") + ": " + P + " type `" + $ + "." + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + C + "`."
      );
    }
    function le(b) {
      function P($, k, C, V, I) {
        var M = $[k], j = te(M);
        if (j !== "object")
          return new h("Invalid " + V + " `" + I + "` of type `" + j + "` " + ("supplied to `" + C + "`, expected `object`."));
        for (var F in b) {
          var L = b[F];
          if (typeof L != "function")
            return se(C, V, I, F, K(L));
          var x = L(M, F, C, V, I + "." + F, e);
          if (x)
            return x;
        }
        return null;
      }
      return m(P);
    }
    function O(b) {
      function P($, k, C, V, I) {
        var M = $[k], j = te(M);
        if (j !== "object")
          return new h("Invalid " + V + " `" + I + "` of type `" + j + "` " + ("supplied to `" + C + "`, expected `object`."));
        var F = t({}, $[k], b);
        for (var L in F) {
          var x = b[L];
          if (n(b, L) && typeof x != "function")
            return se(C, V, I, L, K(x));
          if (!x)
            return new h(
              "Invalid " + V + " `" + I + "` key `" + L + "` supplied to `" + C + "`.\nBad object: " + JSON.stringify($[k], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(b), null, "  ")
            );
          var T = x(M, L, C, V, I + "." + L, e);
          if (T)
            return T;
        }
        return null;
      }
      return m(P);
    }
    function H(b) {
      switch (typeof b) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !b;
        case "object":
          if (Array.isArray(b))
            return b.every(H);
          if (b === null || v(b))
            return !0;
          var P = o(b);
          if (P) {
            var $ = P.call(b), k;
            if (P !== b.entries) {
              for (; !(k = $.next()).done; )
                if (!H(k.value))
                  return !1;
            } else
              for (; !(k = $.next()).done; ) {
                var C = k.value;
                if (C && !H(C[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function oe(b, P) {
      return b === "symbol" ? !0 : P ? P["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && P instanceof Symbol : !1;
    }
    function te(b) {
      var P = typeof b;
      return Array.isArray(b) ? "array" : b instanceof RegExp ? "object" : oe(P, b) ? "symbol" : P;
    }
    function K(b) {
      if (typeof b > "u" || b === null)
        return "" + b;
      var P = te(b);
      if (P === "object") {
        if (b instanceof Date)
          return "date";
        if (b instanceof RegExp)
          return "regexp";
      }
      return P;
    }
    function de(b) {
      var P = K(b);
      switch (P) {
        case "array":
        case "object":
          return "an " + P;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + P;
        default:
          return P;
      }
    }
    function fe(b) {
      return !b.constructor || !b.constructor.name ? a : b.constructor.name;
    }
    return s.checkPropTypes = i, s.resetWarningCache = i.resetWarningCache, s.PropTypes = s, s;
  }, Fr;
}
if (process.env.NODE_ENV !== "production") {
  var yi = ct, mi = !0;
  Kr.exports = hi()(yi.isElement, mi);
} else
  Kr.exports = di()();
var Fn = Kr.exports;
const we = /* @__PURE__ */ Tr(Fn);
var ze = /* @__PURE__ */ me.createContext(null);
process.env.NODE_ENV !== "production" && (ze.displayName = "ReactRedux");
function gi(r) {
  r();
}
var Vn = gi, bi = function(t) {
  return Vn = t;
}, wi = function() {
  return Vn;
};
function Ei() {
  var r = wi(), t = null, e = null;
  return {
    clear: function() {
      t = null, e = null;
    },
    notify: function() {
      r(function() {
        for (var i = t; i; )
          i.callback(), i = i.next;
      });
    },
    get: function() {
      for (var i = [], u = t; u; )
        i.push(u), u = u.next;
      return i;
    },
    subscribe: function(i) {
      var u = !0, c = e = {
        callback: i,
        next: null,
        prev: e
      };
      return c.prev ? c.prev.next = c : t = c, function() {
        !u || t === null || (u = !1, c.next ? c.next.prev = c.prev : e = c.prev, c.prev ? c.prev.next = c.next : t = c.next);
      };
    }
  };
}
var rn = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function ft(r, t) {
  var e, n = rn;
  function i(o) {
    return f(), n.subscribe(o);
  }
  function u() {
    n.notify();
  }
  function c() {
    y.onStateChange && y.onStateChange();
  }
  function v() {
    return !!e;
  }
  function f() {
    e || (e = t ? t.addNestedSub(c) : r.subscribe(c), n = Ei());
  }
  function p() {
    e && (e(), e = void 0, n.clear(), n = rn);
  }
  var y = {
    addNestedSub: i,
    notifyNestedSubs: u,
    handleChangeWrapper: c,
    isSubscribed: v,
    trySubscribe: f,
    tryUnsubscribe: p,
    getListeners: function() {
      return n;
    }
  };
  return y;
}
var mr = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? oi : ii;
function lr(r) {
  var t = r.store, e = r.context, n = r.children, i = Ee(function() {
    var v = ft(t);
    return {
      store: t,
      subscription: v
    };
  }, [t]), u = Ee(function() {
    return t.getState();
  }, [t]);
  mr(function() {
    var v = i.subscription;
    return v.onStateChange = v.notifyNestedSubs, v.trySubscribe(), u !== t.getState() && v.notifyNestedSubs(), function() {
      v.tryUnsubscribe(), v.onStateChange = null;
    };
  }, [i, u]);
  var c = e || ze;
  return /* @__PURE__ */ me.createElement(c.Provider, {
    value: i
  }, n);
}
process.env.NODE_ENV !== "production" && (lr.propTypes = {
  store: we.shape({
    subscribe: we.func.isRequired,
    dispatch: we.func.isRequired,
    getState: we.func.isRequired
  }),
  context: we.object,
  children: we.any
});
function Ne() {
  return Ne = Object.assign ? Object.assign.bind() : function(r) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }, Ne.apply(this, arguments);
}
function gr(r, t) {
  if (r == null)
    return {};
  var e = {}, n = Object.keys(r), i, u;
  for (u = 0; u < n.length; u++)
    i = n[u], !(t.indexOf(i) >= 0) && (e[i] = r[i]);
  return e;
}
var lt = ct, Si = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Ti = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Ai = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Hn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, dt = {};
dt[lt.ForwardRef] = Ai;
dt[lt.Memo] = Hn;
function tn(r) {
  return lt.isMemo(r) ? Hn : dt[r.$$typeof] || Si;
}
var Pi = Object.defineProperty, Oi = Object.getOwnPropertyNames, nn = Object.getOwnPropertySymbols, xi = Object.getOwnPropertyDescriptor, Ri = Object.getPrototypeOf, on = Object.prototype;
function Yn(r, t, e) {
  if (typeof t != "string") {
    if (on) {
      var n = Ri(t);
      n && n !== on && Yn(r, n, e);
    }
    var i = Oi(t);
    nn && (i = i.concat(nn(t)));
    for (var u = tn(r), c = tn(t), v = 0; v < i.length; ++v) {
      var f = i[v];
      if (!Ti[f] && !(e && e[f]) && !(c && c[f]) && !(u && u[f])) {
        var p = xi(t, f);
        try {
          Pi(r, f, p);
        } catch {
        }
      }
    }
  }
  return r;
}
var Ii = Yn;
const an = /* @__PURE__ */ Tr(Ii);
var Zr = { exports: {} }, Q = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var un;
function Ci() {
  return un || (un = 1, process.env.NODE_ENV !== "production" && function() {
    var r = 60103, t = 60106, e = 60107, n = 60108, i = 60114, u = 60109, c = 60110, v = 60112, f = 60113, p = 60120, y = 60115, o = 60116, a = 60121, s = 60122, d = 60117, h = 60129, m = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var l = Symbol.for;
      r = l("react.element"), t = l("react.portal"), e = l("react.fragment"), n = l("react.strict_mode"), i = l("react.profiler"), u = l("react.provider"), c = l("react.context"), v = l("react.forward_ref"), f = l("react.suspense"), p = l("react.suspense_list"), y = l("react.memo"), o = l("react.lazy"), a = l("react.block"), s = l("react.server.block"), d = l("react.fundamental"), l("react.scope"), l("react.opaque.id"), h = l("react.debug_trace_mode"), l("react.offscreen"), m = l("react.legacy_hidden");
    }
    var g = !1;
    function S(x) {
      return !!(typeof x == "string" || typeof x == "function" || x === e || x === i || x === h || x === n || x === f || x === p || x === m || g || typeof x == "object" && x !== null && (x.$$typeof === o || x.$$typeof === y || x.$$typeof === u || x.$$typeof === c || x.$$typeof === v || x.$$typeof === d || x.$$typeof === a || x[0] === s));
    }
    function A(x) {
      if (typeof x == "object" && x !== null) {
        var T = x.$$typeof;
        switch (T) {
          case r:
            var ie = x.type;
            switch (ie) {
              case e:
              case i:
              case n:
              case f:
              case p:
                return ie;
              default:
                var _e = ie && ie.$$typeof;
                switch (_e) {
                  case c:
                  case v:
                  case o:
                  case y:
                  case u:
                    return _e;
                  default:
                    return T;
                }
            }
          case t:
            return T;
        }
      }
    }
    var w = c, X = u, q = r, B = v, N = e, ce = o, se = y, le = t, O = i, H = n, oe = f, te = !1, K = !1;
    function de(x) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function fe(x) {
      return K || (K = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function b(x) {
      return A(x) === c;
    }
    function P(x) {
      return A(x) === u;
    }
    function $(x) {
      return typeof x == "object" && x !== null && x.$$typeof === r;
    }
    function k(x) {
      return A(x) === v;
    }
    function C(x) {
      return A(x) === e;
    }
    function V(x) {
      return A(x) === o;
    }
    function I(x) {
      return A(x) === y;
    }
    function M(x) {
      return A(x) === t;
    }
    function j(x) {
      return A(x) === i;
    }
    function F(x) {
      return A(x) === n;
    }
    function L(x) {
      return A(x) === f;
    }
    Q.ContextConsumer = w, Q.ContextProvider = X, Q.Element = q, Q.ForwardRef = B, Q.Fragment = N, Q.Lazy = ce, Q.Memo = se, Q.Portal = le, Q.Profiler = O, Q.StrictMode = H, Q.Suspense = oe, Q.isAsyncMode = de, Q.isConcurrentMode = fe, Q.isContextConsumer = b, Q.isContextProvider = P, Q.isElement = $, Q.isForwardRef = k, Q.isFragment = C, Q.isLazy = V, Q.isMemo = I, Q.isPortal = M, Q.isProfiler = j, Q.isStrictMode = F, Q.isSuspense = L, Q.isValidElementType = S, Q.typeOf = A;
  }()), Q;
}
var Z = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sn;
function ki() {
  if (sn)
    return Z;
  sn = 1;
  var r = 60103, t = 60106, e = 60107, n = 60108, i = 60114, u = 60109, c = 60110, v = 60112, f = 60113, p = 60120, y = 60115, o = 60116, a = 60121, s = 60122, d = 60117, h = 60129, m = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var l = Symbol.for;
    r = l("react.element"), t = l("react.portal"), e = l("react.fragment"), n = l("react.strict_mode"), i = l("react.profiler"), u = l("react.provider"), c = l("react.context"), v = l("react.forward_ref"), f = l("react.suspense"), p = l("react.suspense_list"), y = l("react.memo"), o = l("react.lazy"), a = l("react.block"), s = l("react.server.block"), d = l("react.fundamental"), h = l("react.debug_trace_mode"), m = l("react.legacy_hidden");
  }
  function g(O) {
    if (typeof O == "object" && O !== null) {
      var H = O.$$typeof;
      switch (H) {
        case r:
          switch (O = O.type, O) {
            case e:
            case i:
            case n:
            case f:
            case p:
              return O;
            default:
              switch (O = O && O.$$typeof, O) {
                case c:
                case v:
                case o:
                case y:
                case u:
                  return O;
                default:
                  return H;
              }
          }
        case t:
          return H;
      }
    }
  }
  var S = u, A = r, w = v, X = e, q = o, B = y, N = t, ce = i, se = n, le = f;
  return Z.ContextConsumer = c, Z.ContextProvider = S, Z.Element = A, Z.ForwardRef = w, Z.Fragment = X, Z.Lazy = q, Z.Memo = B, Z.Portal = N, Z.Profiler = ce, Z.StrictMode = se, Z.Suspense = le, Z.isAsyncMode = function() {
    return !1;
  }, Z.isConcurrentMode = function() {
    return !1;
  }, Z.isContextConsumer = function(O) {
    return g(O) === c;
  }, Z.isContextProvider = function(O) {
    return g(O) === u;
  }, Z.isElement = function(O) {
    return typeof O == "object" && O !== null && O.$$typeof === r;
  }, Z.isForwardRef = function(O) {
    return g(O) === v;
  }, Z.isFragment = function(O) {
    return g(O) === e;
  }, Z.isLazy = function(O) {
    return g(O) === o;
  }, Z.isMemo = function(O) {
    return g(O) === y;
  }, Z.isPortal = function(O) {
    return g(O) === t;
  }, Z.isProfiler = function(O) {
    return g(O) === i;
  }, Z.isStrictMode = function(O) {
    return g(O) === n;
  }, Z.isSuspense = function(O) {
    return g(O) === f;
  }, Z.isValidElementType = function(O) {
    return typeof O == "string" || typeof O == "function" || O === e || O === i || O === h || O === n || O === f || O === p || O === m || typeof O == "object" && O !== null && (O.$$typeof === o || O.$$typeof === y || O.$$typeof === u || O.$$typeof === c || O.$$typeof === v || O.$$typeof === d || O.$$typeof === a || O[0] === s);
  }, Z.typeOf = g, Z;
}
process.env.NODE_ENV === "production" ? Zr.exports = ki() : Zr.exports = Ci();
var cn = Zr.exports, Mi = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"], Di = ["reactReduxForwardedRef"], $i = [], Ni = [null, null], ji = function(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
};
function Li(r, t) {
  var e = r[1];
  return [t.payload, e + 1];
}
function fn(r, t, e) {
  mr(function() {
    return r.apply(void 0, t);
  }, e);
}
function Fi(r, t, e, n, i, u, c) {
  r.current = n, t.current = i, e.current = !1, u.current && (u.current = null, c());
}
function Vi(r, t, e, n, i, u, c, v, f, p) {
  if (r) {
    var y = !1, o = null, a = function() {
      if (!y) {
        var h = t.getState(), m, l;
        try {
          m = n(h, i.current);
        } catch (g) {
          l = g, o = g;
        }
        l || (o = null), m === u.current ? c.current || f() : (u.current = m, v.current = m, c.current = !0, p({
          type: "STORE_UPDATED",
          payload: {
            error: l
          }
        }));
      }
    };
    e.onStateChange = a, e.trySubscribe(), a();
    var s = function() {
      if (y = !0, e.tryUnsubscribe(), e.onStateChange = null, o)
        throw o;
    };
    return s;
  }
}
var Hi = function() {
  return [null, 0];
};
function Yi(r, t) {
  t === void 0 && (t = {});
  var e = t, n = e.getDisplayName, i = n === void 0 ? function(X) {
    return "ConnectAdvanced(" + X + ")";
  } : n, u = e.methodName, c = u === void 0 ? "connectAdvanced" : u, v = e.renderCountProp, f = v === void 0 ? void 0 : v, p = e.shouldHandleStateChanges, y = p === void 0 ? !0 : p, o = e.storeKey, a = o === void 0 ? "store" : o, s = e.withRef, d = s === void 0 ? !1 : s, h = e.forwardRef, m = h === void 0 ? !1 : h, l = e.context, g = l === void 0 ? ze : l, S = gr(e, Mi);
  if (process.env.NODE_ENV !== "production") {
    if (f !== void 0)
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    if (d)
      throw new Error("withRef is removed. To access the wrapped instance, use a ref on the connected component");
    var A = "To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    if (a !== "store")
      throw new Error("storeKey has been removed and does not do anything. " + A);
  }
  var w = g;
  return function(q) {
    if (process.env.NODE_ENV !== "production" && !cn.isValidElementType(q))
      throw new Error("You must pass a component to the function returned by " + (c + ". Instead received " + ji(q)));
    var B = q.displayName || q.name || "Component", N = i(B), ce = Ne({}, S, {
      getDisplayName: i,
      methodName: c,
      renderCountProp: f,
      shouldHandleStateChanges: y,
      storeKey: a,
      displayName: N,
      wrappedComponentName: B,
      WrappedComponent: q
    }), se = S.pure;
    function le(K) {
      return r(K.dispatch, ce);
    }
    var O = se ? Ee : function(K) {
      return K();
    };
    function H(K) {
      var de = Ee(function() {
        var ke = K.reactReduxForwardedRef, Ge = gr(K, Di);
        return [K.context, ke, Ge];
      }, [K]), fe = de[0], b = de[1], P = de[2], $ = Ee(function() {
        return fe && fe.Consumer && cn.isContextConsumer(/* @__PURE__ */ me.createElement(fe.Consumer, null)) ? fe : w;
      }, [fe, w]), k = at($), C = !!K.store && !!K.store.getState && !!K.store.dispatch, V = !!k && !!k.store;
      if (process.env.NODE_ENV !== "production" && !C && !V)
        throw new Error('Could not find "store" in the context of ' + ('"' + N + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + N + " in connect options."));
      var I = C ? K.store : k.store, M = Ee(function() {
        return le(I);
      }, [I]), j = Ee(function() {
        if (!y)
          return Ni;
        var ke = ft(I, C ? null : k.subscription), Ge = ke.notifyNestedSubs.bind(ke);
        return [ke, Ge];
      }, [I, C, k]), F = j[0], L = j[1], x = Ee(function() {
        return C ? k : Ne({}, k, {
          subscription: F
        });
      }, [C, k, F]), T = jn(Li, $i, Hi), ie = T[0], _e = ie[0], Pe = T[1];
      if (_e && _e.error)
        throw _e.error;
      var ar = $e(), We = $e(P), Oe = $e(), _r = $e(!1), xe = O(function() {
        return Oe.current && P === We.current ? Oe.current : M(I.getState(), P);
      }, [I, _e, P]);
      fn(Fi, [We, ar, _r, P, xe, Oe, L]), fn(Vi, [y, I, F, M, We, ar, _r, Oe, L, Pe], [I, F, M]);
      var Fe = Ee(function() {
        return /* @__PURE__ */ me.createElement(q, Ne({}, xe, {
          ref: b
        }));
      }, [b, q, xe]), xr = Ee(function() {
        return y ? /* @__PURE__ */ me.createElement($.Provider, {
          value: x
        }, Fe) : Fe;
      }, [$, Fe, x]);
      return xr;
    }
    var oe = se ? me.memo(H) : H;
    if (oe.WrappedComponent = q, oe.displayName = H.displayName = N, m) {
      var te = me.forwardRef(function(de, fe) {
        return /* @__PURE__ */ me.createElement(oe, Ne({}, de, {
          reactReduxForwardedRef: fe
        }));
      });
      return te.displayName = N, te.WrappedComponent = q, an(te, q);
    }
    return an(oe, q);
  };
}
function ln(r, t) {
  return r === t ? r !== 0 || t !== 0 || 1 / r === 1 / t : r !== r && t !== t;
}
function Vr(r, t) {
  if (ln(r, t))
    return !0;
  if (typeof r != "object" || r === null || typeof t != "object" || t === null)
    return !1;
  var e = Object.keys(r), n = Object.keys(t);
  if (e.length !== n.length)
    return !1;
  for (var i = 0; i < e.length; i++)
    if (!Object.prototype.hasOwnProperty.call(t, e[i]) || !ln(r[e[i]], t[e[i]]))
      return !1;
  return !0;
}
function qi(r, t) {
  var e = {}, n = function(c) {
    var v = r[c];
    typeof v == "function" && (e[c] = function() {
      return t(v.apply(void 0, arguments));
    });
  };
  for (var i in r)
    n(i);
  return e;
}
function Ui(r) {
  if (typeof r != "object" || r === null)
    return !1;
  var t = Object.getPrototypeOf(r);
  if (t === null)
    return !0;
  for (var e = t; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return t === e;
}
function qn(r) {
  typeof console < "u" && typeof console.error == "function" && console.error(r);
  try {
    throw new Error(r);
  } catch {
  }
}
function Un(r, t, e) {
  Ui(r) || qn(e + "() in " + t + " must return a plain object. Instead received " + r + ".");
}
function pt(r) {
  return function(e, n) {
    var i = r(e, n);
    function u() {
      return i;
    }
    return u.dependsOnOwnProps = !1, u;
  };
}
function dn(r) {
  return r.dependsOnOwnProps !== null && r.dependsOnOwnProps !== void 0 ? !!r.dependsOnOwnProps : r.length !== 1;
}
function Bn(r, t) {
  return function(n, i) {
    var u = i.displayName, c = function(f, p) {
      return c.dependsOnOwnProps ? c.mapToProps(f, p) : c.mapToProps(f);
    };
    return c.dependsOnOwnProps = !0, c.mapToProps = function(f, p) {
      c.mapToProps = r, c.dependsOnOwnProps = dn(r);
      var y = c(f, p);
      return typeof y == "function" && (c.mapToProps = y, c.dependsOnOwnProps = dn(y), y = c(f, p)), process.env.NODE_ENV !== "production" && Un(y, u, t), y;
    }, c;
  };
}
function Bi(r) {
  return typeof r == "function" ? Bn(r, "mapDispatchToProps") : void 0;
}
function Wi(r) {
  return r ? void 0 : pt(function(t) {
    return {
      dispatch: t
    };
  });
}
function Gi(r) {
  return r && typeof r == "object" ? pt(function(t) {
    return qi(r, t);
  }) : void 0;
}
const Xi = [Bi, Wi, Gi];
function Ki(r) {
  return typeof r == "function" ? Bn(r, "mapStateToProps") : void 0;
}
function Qi(r) {
  return r ? void 0 : pt(function() {
    return {};
  });
}
const Zi = [Ki, Qi];
function Ji(r, t, e) {
  return Ne({}, e, r, t);
}
function zi(r) {
  return function(e, n) {
    var i = n.displayName, u = n.pure, c = n.areMergedPropsEqual, v = !1, f;
    return function(y, o, a) {
      var s = r(y, o, a);
      return v ? (!u || !c(s, f)) && (f = s) : (v = !0, f = s, process.env.NODE_ENV !== "production" && Un(f, i, "mergeProps")), f;
    };
  };
}
function ea(r) {
  return typeof r == "function" ? zi(r) : void 0;
}
function ra(r) {
  return r ? void 0 : function() {
    return Ji;
  };
}
const ta = [ea, ra];
function Hr(r, t, e) {
  if (r)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(r, "dependsOnOwnProps") || qn("The selector for " + t + " of " + e + " did not specify a value for dependsOnOwnProps."));
  else
    throw new Error("Unexpected value for " + t + " in " + e + ".");
}
function na(r, t, e, n) {
  Hr(r, "mapStateToProps", n), Hr(t, "mapDispatchToProps", n), Hr(e, "mergeProps", n);
}
var oa = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function ia(r, t, e, n) {
  return function(u, c) {
    return e(r(u, c), t(n, c), c);
  };
}
function aa(r, t, e, n, i) {
  var u = i.areStatesEqual, c = i.areOwnPropsEqual, v = i.areStatePropsEqual, f = !1, p, y, o, a, s;
  function d(S, A) {
    return p = S, y = A, o = r(p, y), a = t(n, y), s = e(o, a, y), f = !0, s;
  }
  function h() {
    return o = r(p, y), t.dependsOnOwnProps && (a = t(n, y)), s = e(o, a, y), s;
  }
  function m() {
    return r.dependsOnOwnProps && (o = r(p, y)), t.dependsOnOwnProps && (a = t(n, y)), s = e(o, a, y), s;
  }
  function l() {
    var S = r(p, y), A = !v(S, o);
    return o = S, A && (s = e(o, a, y)), s;
  }
  function g(S, A) {
    var w = !c(A, y), X = !u(S, p, A, y);
    return p = S, y = A, w && X ? h() : w ? m() : X ? l() : s;
  }
  return function(A, w) {
    return f ? g(A, w) : d(A, w);
  };
}
function ua(r, t) {
  var e = t.initMapStateToProps, n = t.initMapDispatchToProps, i = t.initMergeProps, u = gr(t, oa), c = e(r, u), v = n(r, u), f = i(r, u);
  process.env.NODE_ENV !== "production" && na(c, v, f, u.displayName);
  var p = u.pure ? aa : ia;
  return p(c, v, f, r, u);
}
var sa = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
function Yr(r, t, e) {
  for (var n = t.length - 1; n >= 0; n--) {
    var i = t[n](r);
    if (i)
      return i;
  }
  return function(u, c) {
    throw new Error("Invalid value of type " + typeof r + " for " + e + " argument when connecting component " + c.wrappedComponentName + ".");
  };
}
function ca(r, t) {
  return r === t;
}
function fa(r) {
  var t = r === void 0 ? {} : r, e = t.connectHOC, n = e === void 0 ? Yi : e, i = t.mapStateToPropsFactories, u = i === void 0 ? Zi : i, c = t.mapDispatchToPropsFactories, v = c === void 0 ? Xi : c, f = t.mergePropsFactories, p = f === void 0 ? ta : f, y = t.selectorFactory, o = y === void 0 ? ua : y;
  return function(s, d, h, m) {
    m === void 0 && (m = {});
    var l = m, g = l.pure, S = g === void 0 ? !0 : g, A = l.areStatesEqual, w = A === void 0 ? ca : A, X = l.areOwnPropsEqual, q = X === void 0 ? Vr : X, B = l.areStatePropsEqual, N = B === void 0 ? Vr : B, ce = l.areMergedPropsEqual, se = ce === void 0 ? Vr : ce, le = gr(l, sa), O = Yr(s, u, "mapStateToProps"), H = Yr(d, v, "mapDispatchToProps"), oe = Yr(h, p, "mergeProps");
    return n(o, Ne({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function(K) {
        return "Connect(" + K + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: !!s,
      // passed through to selectorFactory
      initMapStateToProps: O,
      initMapDispatchToProps: H,
      initMergeProps: oe,
      pure: S,
      areStatesEqual: w,
      areOwnPropsEqual: q,
      areStatePropsEqual: N,
      areMergedPropsEqual: se
    }, le));
  };
}
const vt = /* @__PURE__ */ fa();
function la() {
  var r = at(ze);
  if (process.env.NODE_ENV !== "production" && !r)
    throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
  return r;
}
var da = function(t, e) {
  return t === e;
};
function pa(r, t, e, n) {
  var i = jn(function(d) {
    return d + 1;
  }, 0), u = i[1], c = Ee(function() {
    return ft(e, n);
  }, [e, n]), v = $e(), f = $e(), p = $e(), y = $e(), o = e.getState(), a;
  try {
    if (r !== f.current || o !== p.current || v.current) {
      var s = r(o);
      y.current === void 0 || !t(s, y.current) ? a = s : a = y.current;
    } else
      a = y.current;
  } catch (d) {
    throw v.current && (d.message += `
The error may be correlated with this previous error:
` + v.current.stack + `

`), d;
  }
  return mr(function() {
    f.current = r, p.current = o, y.current = a, v.current = void 0;
  }), mr(function() {
    function d() {
      try {
        var h = e.getState();
        if (h === p.current)
          return;
        var m = f.current(h);
        if (t(m, y.current))
          return;
        y.current = m, p.current = h;
      } catch (l) {
        v.current = l;
      }
      u();
    }
    return c.onStateChange = d, c.trySubscribe(), d(), function() {
      return c.tryUnsubscribe();
    };
  }, [e, c]), a;
}
function va(r) {
  r === void 0 && (r = ze);
  var t = r === ze ? la : function() {
    return at(r);
  };
  return function(n, i) {
    if (i === void 0 && (i = da), process.env.NODE_ENV !== "production") {
      if (!n)
        throw new Error("You must pass a selector to useSelector");
      if (typeof n != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof i != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    var u = t(), c = u.store, v = u.subscription, f = pa(n, i, c, v);
    return ai(f), f;
  };
}
bi(ci);
function fr(r) {
  "@babel/helpers - typeof";
  return fr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fr(r);
}
function _a(r, t) {
  if (fr(r) != "object" || !r)
    return r;
  var e = r[Symbol.toPrimitive];
  if (e !== void 0) {
    var n = e.call(r, t || "default");
    if (fr(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(r);
}
function ha(r) {
  var t = _a(r, "string");
  return fr(t) == "symbol" ? t : String(t);
}
function ya(r, t, e) {
  return t = ha(t), t in r ? Object.defineProperty(r, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[t] = e, r;
}
function pn(r, t) {
  var e = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function vn(r) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pn(Object(e), !0).forEach(function(n) {
      ya(r, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : pn(Object(e)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }
  return r;
}
function ye(r) {
  return "Minified Redux error #" + r + "; visit https://redux.js.org/Errors?code=" + r + " for the full message or use the non-minified dev environment for full errors. ";
}
var _n = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), qr = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, hn = {
  INIT: "@@redux/INIT" + qr(),
  REPLACE: "@@redux/REPLACE" + qr(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + qr();
  }
};
function ma(r) {
  if (typeof r != "object" || r === null)
    return !1;
  for (var t = r; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(r) === t;
}
function ga(r) {
  if (r === void 0)
    return "undefined";
  if (r === null)
    return "null";
  var t = typeof r;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(r))
    return "array";
  if (Ea(r))
    return "date";
  if (wa(r))
    return "error";
  var e = ba(r);
  switch (e) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return e;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ba(r) {
  return typeof r.constructor == "function" ? r.constructor.name : null;
}
function wa(r) {
  return r instanceof Error || typeof r.message == "string" && r.constructor && typeof r.constructor.stackTraceLimit == "number";
}
function Ea(r) {
  return r instanceof Date ? !0 : typeof r.toDateString == "function" && typeof r.getDate == "function" && typeof r.setDate == "function";
}
function Ze(r) {
  var t = typeof r;
  return process.env.NODE_ENV !== "production" && (t = ga(r)), t;
}
function Wn(r, t, e) {
  var n;
  if (typeof t == "function" && typeof e == "function" || typeof e == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? ye(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof e > "u" && (e = t, t = void 0), typeof e < "u") {
    if (typeof e != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ye(1) : "Expected the enhancer to be a function. Instead, received: '" + Ze(e) + "'");
    return e(Wn)(r, t);
  }
  if (typeof r != "function")
    throw new Error(process.env.NODE_ENV === "production" ? ye(2) : "Expected the root reducer to be a function. Instead, received: '" + Ze(r) + "'");
  var i = r, u = t, c = [], v = c, f = !1;
  function p() {
    v === c && (v = c.slice());
  }
  function y() {
    if (f)
      throw new Error(process.env.NODE_ENV === "production" ? ye(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return u;
  }
  function o(h) {
    if (typeof h != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ye(4) : "Expected the listener to be a function. Instead, received: '" + Ze(h) + "'");
    if (f)
      throw new Error(process.env.NODE_ENV === "production" ? ye(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var m = !0;
    return p(), v.push(h), function() {
      if (m) {
        if (f)
          throw new Error(process.env.NODE_ENV === "production" ? ye(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        m = !1, p();
        var g = v.indexOf(h);
        v.splice(g, 1), c = null;
      }
    };
  }
  function a(h) {
    if (!ma(h))
      throw new Error(process.env.NODE_ENV === "production" ? ye(7) : "Actions must be plain objects. Instead, the actual type was: '" + Ze(h) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof h.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? ye(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (f)
      throw new Error(process.env.NODE_ENV === "production" ? ye(9) : "Reducers may not dispatch actions.");
    try {
      f = !0, u = i(u, h);
    } finally {
      f = !1;
    }
    for (var m = c = v, l = 0; l < m.length; l++) {
      var g = m[l];
      g();
    }
    return h;
  }
  function s(h) {
    if (typeof h != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ye(10) : "Expected the nextReducer to be a function. Instead, received: '" + Ze(h));
    i = h, a({
      type: hn.REPLACE
    });
  }
  function d() {
    var h, m = o;
    return h = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(g) {
        if (typeof g != "object" || g === null)
          throw new Error(process.env.NODE_ENV === "production" ? ye(11) : "Expected the observer to be an object. Instead, received: '" + Ze(g) + "'");
        function S() {
          g.next && g.next(y());
        }
        S();
        var A = m(S);
        return {
          unsubscribe: A
        };
      }
    }, h[_n] = function() {
      return this;
    }, h;
  }
  return a({
    type: hn.INIT
  }), n = {
    dispatch: a,
    subscribe: o,
    getState: y,
    replaceReducer: s
  }, n[_n] = d, n;
}
function Gn() {
  for (var r = arguments.length, t = new Array(r), e = 0; e < r; e++)
    t[e] = arguments[e];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, i) {
    return function() {
      return n(i.apply(void 0, arguments));
    };
  });
}
function Sa() {
  for (var r = arguments.length, t = new Array(r), e = 0; e < r; e++)
    t[e] = arguments[e];
  return function(n) {
    return function() {
      var i = n.apply(void 0, arguments), u = function() {
        throw new Error(process.env.NODE_ENV === "production" ? ye(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, c = {
        getState: i.getState,
        dispatch: function() {
          return u.apply(void 0, arguments);
        }
      }, v = t.map(function(f) {
        return f(c);
      });
      return u = Gn.apply(void 0, v)(i.dispatch), vn(vn({}, i), {}, {
        dispatch: u
      });
    };
  };
}
var Jr = function(r, t) {
  return Jr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
  }, Jr(r, t);
};
function Ae(r, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Jr(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
function Ta(r, t, e, n) {
  function i(u) {
    return u instanceof e ? u : new e(function(c) {
      c(u);
    });
  }
  return new (e || (e = Promise))(function(u, c) {
    function v(y) {
      try {
        p(n.next(y));
      } catch (o) {
        c(o);
      }
    }
    function f(y) {
      try {
        p(n.throw(y));
      } catch (o) {
        c(o);
      }
    }
    function p(y) {
      y.done ? u(y.value) : i(y.value).then(v, f);
    }
    p((n = n.apply(r, t || [])).next());
  });
}
function Xn(r, t) {
  var e = { label: 0, sent: function() {
    if (u[0] & 1)
      throw u[1];
    return u[1];
  }, trys: [], ops: [] }, n, i, u, c;
  return c = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function v(p) {
    return function(y) {
      return f([p, y]);
    };
  }
  function f(p) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; c && (c = 0, p[0] && (e = 0)), e; )
      try {
        if (n = 1, i && (u = p[0] & 2 ? i.return : p[0] ? i.throw || ((u = i.return) && u.call(i), 0) : i.next) && !(u = u.call(i, p[1])).done)
          return u;
        switch (i = 0, u && (p = [p[0] & 2, u.value]), p[0]) {
          case 0:
          case 1:
            u = p;
            break;
          case 4:
            return e.label++, { value: p[1], done: !1 };
          case 5:
            e.label++, i = p[1], p = [0];
            continue;
          case 7:
            p = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (u = e.trys, !(u = u.length > 0 && u[u.length - 1]) && (p[0] === 6 || p[0] === 2)) {
              e = 0;
              continue;
            }
            if (p[0] === 3 && (!u || p[1] > u[0] && p[1] < u[3])) {
              e.label = p[1];
              break;
            }
            if (p[0] === 6 && e.label < u[1]) {
              e.label = u[1], u = p;
              break;
            }
            if (u && e.label < u[2]) {
              e.label = u[2], e.ops.push(p);
              break;
            }
            u[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        p = t.call(r, e);
      } catch (y) {
        p = [6, y], i = 0;
      } finally {
        n = u = 0;
      }
    if (p[0] & 5)
      throw p[1];
    return { value: p[0] ? p[1] : void 0, done: !0 };
  }
}
function er(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
  if (e)
    return e.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function rr(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e)
    return r;
  var n = e.call(r), i, u = [], c;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      u.push(i.value);
  } catch (v) {
    c = { error: v };
  } finally {
    try {
      i && !i.done && (e = n.return) && e.call(n);
    } finally {
      if (c)
        throw c.error;
    }
  }
  return u;
}
function tr(r, t, e) {
  if (e || arguments.length === 2)
    for (var n = 0, i = t.length, u; n < i; n++)
      (u || !(n in t)) && (u || (u = Array.prototype.slice.call(t, 0, n)), u[n] = t[n]);
  return r.concat(u || Array.prototype.slice.call(t));
}
function Je(r) {
  return this instanceof Je ? (this.v = r, this) : new Je(r);
}
function Aa(r, t, e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = e.apply(r, t || []), i, u = [];
  return i = {}, c("next"), c("throw"), c("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function c(a) {
    n[a] && (i[a] = function(s) {
      return new Promise(function(d, h) {
        u.push([a, s, d, h]) > 1 || v(a, s);
      });
    });
  }
  function v(a, s) {
    try {
      f(n[a](s));
    } catch (d) {
      o(u[0][3], d);
    }
  }
  function f(a) {
    a.value instanceof Je ? Promise.resolve(a.value.v).then(p, y) : o(u[0][2], a);
  }
  function p(a) {
    v("next", a);
  }
  function y(a) {
    v("throw", a);
  }
  function o(a, s) {
    a(s), u.shift(), u.length && v(u[0][0], u[0][1]);
  }
}
function Pa(r) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = r[Symbol.asyncIterator], e;
  return t ? t.call(r) : (r = typeof er == "function" ? er(r) : r[Symbol.iterator](), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function() {
    return this;
  }, e);
  function n(u) {
    e[u] = r[u] && function(c) {
      return new Promise(function(v, f) {
        c = r[u](c), i(v, f, c.done, c.value);
      });
    };
  }
  function i(u, c, v, f) {
    Promise.resolve(f).then(function(p) {
      u({ value: p, done: v });
    }, c);
  }
}
function ue(r) {
  return typeof r == "function";
}
function Kn(r) {
  var t = function(n) {
    Error.call(n), n.stack = new Error().stack;
  }, e = r(t);
  return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
}
var Ur = Kn(function(r) {
  return function(e) {
    r(this), this.message = e ? e.length + ` errors occurred during unsubscription:
` + e.map(function(n, i) {
      return i + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = e;
  };
});
function br(r, t) {
  if (r) {
    var e = r.indexOf(t);
    0 <= e && r.splice(e, 1);
  }
}
var dr = function() {
  function r(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return r.prototype.unsubscribe = function() {
    var t, e, n, i, u;
    if (!this.closed) {
      this.closed = !0;
      var c = this._parentage;
      if (c)
        if (this._parentage = null, Array.isArray(c))
          try {
            for (var v = er(c), f = v.next(); !f.done; f = v.next()) {
              var p = f.value;
              p.remove(this);
            }
          } catch (h) {
            t = { error: h };
          } finally {
            try {
              f && !f.done && (e = v.return) && e.call(v);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          c.remove(this);
      var y = this.initialTeardown;
      if (ue(y))
        try {
          y();
        } catch (h) {
          u = h instanceof Ur ? h.errors : [h];
        }
      var o = this._finalizers;
      if (o) {
        this._finalizers = null;
        try {
          for (var a = er(o), s = a.next(); !s.done; s = a.next()) {
            var d = s.value;
            try {
              yn(d);
            } catch (h) {
              u = u ?? [], h instanceof Ur ? u = tr(tr([], rr(u)), rr(h.errors)) : u.push(h);
            }
          }
        } catch (h) {
          n = { error: h };
        } finally {
          try {
            s && !s.done && (i = a.return) && i.call(a);
          } finally {
            if (n)
              throw n.error;
          }
        }
      }
      if (u)
        throw new Ur(u);
    }
  }, r.prototype.add = function(t) {
    var e;
    if (t && t !== this)
      if (this.closed)
        yn(t);
      else {
        if (t instanceof r) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (e = this._finalizers) !== null && e !== void 0 ? e : []).push(t);
      }
  }, r.prototype._hasParent = function(t) {
    var e = this._parentage;
    return e === t || Array.isArray(e) && e.includes(t);
  }, r.prototype._addParent = function(t) {
    var e = this._parentage;
    this._parentage = Array.isArray(e) ? (e.push(t), e) : e ? [e, t] : t;
  }, r.prototype._removeParent = function(t) {
    var e = this._parentage;
    e === t ? this._parentage = null : Array.isArray(e) && br(e, t);
  }, r.prototype.remove = function(t) {
    var e = this._finalizers;
    e && br(e, t), t instanceof r && t._removeParent(this);
  }, r.EMPTY = function() {
    var t = new r();
    return t.closed = !0, t;
  }(), r;
}(), Qn = dr.EMPTY;
function Zn(r) {
  return r instanceof dr || r && "closed" in r && ue(r.remove) && ue(r.add) && ue(r.unsubscribe);
}
function yn(r) {
  ue(r) ? r() : r.unsubscribe();
}
var Jn = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, zr = {
  setTimeout: function(r, t) {
    for (var e = [], n = 2; n < arguments.length; n++)
      e[n - 2] = arguments[n];
    var i = zr.delegate;
    return i != null && i.setTimeout ? i.setTimeout.apply(i, tr([r, t], rr(e))) : setTimeout.apply(void 0, tr([r, t], rr(e)));
  },
  clearTimeout: function(r) {
    var t = zr.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(r);
  },
  delegate: void 0
};
function zn(r) {
  zr.setTimeout(function() {
    throw r;
  });
}
function et() {
}
function yr(r) {
  r();
}
var _t = function(r) {
  Ae(t, r);
  function t(e) {
    var n = r.call(this) || this;
    return n.isStopped = !1, e ? (n.destination = e, Zn(e) && e.add(n)) : n.destination = Ia, n;
  }
  return t.create = function(e, n, i) {
    return new rt(e, n, i);
  }, t.prototype.next = function(e) {
    this.isStopped || this._next(e);
  }, t.prototype.error = function(e) {
    this.isStopped || (this.isStopped = !0, this._error(e));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, r.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(e) {
    this.destination.next(e);
  }, t.prototype._error = function(e) {
    try {
      this.destination.error(e);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(dr), Oa = Function.prototype.bind;
function Br(r, t) {
  return Oa.call(r, t);
}
var xa = function() {
  function r(t) {
    this.partialObserver = t;
  }
  return r.prototype.next = function(t) {
    var e = this.partialObserver;
    if (e.next)
      try {
        e.next(t);
      } catch (n) {
        hr(n);
      }
  }, r.prototype.error = function(t) {
    var e = this.partialObserver;
    if (e.error)
      try {
        e.error(t);
      } catch (n) {
        hr(n);
      }
    else
      hr(t);
  }, r.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (e) {
        hr(e);
      }
  }, r;
}(), rt = function(r) {
  Ae(t, r);
  function t(e, n, i) {
    var u = r.call(this) || this, c;
    if (ue(e) || !e)
      c = {
        next: e ?? void 0,
        error: n ?? void 0,
        complete: i ?? void 0
      };
    else {
      var v;
      u && Jn.useDeprecatedNextContext ? (v = Object.create(e), v.unsubscribe = function() {
        return u.unsubscribe();
      }, c = {
        next: e.next && Br(e.next, v),
        error: e.error && Br(e.error, v),
        complete: e.complete && Br(e.complete, v)
      }) : c = e;
    }
    return u.destination = new xa(c), u;
  }
  return t;
}(_t);
function hr(r) {
  zn(r);
}
function Ra(r) {
  throw r;
}
var Ia = {
  closed: !0,
  next: et,
  error: Ra,
  complete: et
}, ht = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function yt(r) {
  return r;
}
function Ca(r) {
  return r.length === 0 ? yt : r.length === 1 ? r[0] : function(e) {
    return r.reduce(function(n, i) {
      return i(n);
    }, e);
  };
}
var ge = function() {
  function r(t) {
    t && (this._subscribe = t);
  }
  return r.prototype.lift = function(t) {
    var e = new r();
    return e.source = this, e.operator = t, e;
  }, r.prototype.subscribe = function(t, e, n) {
    var i = this, u = Ma(t) ? t : new rt(t, e, n);
    return yr(function() {
      var c = i, v = c.operator, f = c.source;
      u.add(v ? v.call(u, f) : f ? i._subscribe(u) : i._trySubscribe(u));
    }), u;
  }, r.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (e) {
      t.error(e);
    }
  }, r.prototype.forEach = function(t, e) {
    var n = this;
    return e = mn(e), new e(function(i, u) {
      var c = new rt({
        next: function(v) {
          try {
            t(v);
          } catch (f) {
            u(f), c.unsubscribe();
          }
        },
        error: u,
        complete: i
      });
      n.subscribe(c);
    });
  }, r.prototype._subscribe = function(t) {
    var e;
    return (e = this.source) === null || e === void 0 ? void 0 : e.subscribe(t);
  }, r.prototype[ht] = function() {
    return this;
  }, r.prototype.pipe = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    return Ca(t)(this);
  }, r.prototype.toPromise = function(t) {
    var e = this;
    return t = mn(t), new t(function(n, i) {
      var u;
      e.subscribe(function(c) {
        return u = c;
      }, function(c) {
        return i(c);
      }, function() {
        return n(u);
      });
    });
  }, r.create = function(t) {
    return new r(t);
  }, r;
}();
function mn(r) {
  var t;
  return (t = r ?? Jn.Promise) !== null && t !== void 0 ? t : Promise;
}
function ka(r) {
  return r && ue(r.next) && ue(r.error) && ue(r.complete);
}
function Ma(r) {
  return r && r instanceof _t || ka(r) && Zn(r);
}
function Da(r) {
  return ue(r == null ? void 0 : r.lift);
}
function Ye(r) {
  return function(t) {
    if (Da(t))
      return t.lift(function(e) {
        try {
          return r(e, this);
        } catch (n) {
          this.error(n);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Ve(r, t, e, n, i) {
  return new $a(r, t, e, n, i);
}
var $a = function(r) {
  Ae(t, r);
  function t(e, n, i, u, c, v) {
    var f = r.call(this, e) || this;
    return f.onFinalize = c, f.shouldUnsubscribe = v, f._next = n ? function(p) {
      try {
        n(p);
      } catch (y) {
        e.error(y);
      }
    } : r.prototype._next, f._error = u ? function(p) {
      try {
        u(p);
      } catch (y) {
        e.error(y);
      } finally {
        this.unsubscribe();
      }
    } : r.prototype._error, f._complete = i ? function() {
      try {
        i();
      } catch (p) {
        e.error(p);
      } finally {
        this.unsubscribe();
      }
    } : r.prototype._complete, f;
  }
  return t.prototype.unsubscribe = function() {
    var e;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var n = this.closed;
      r.prototype.unsubscribe.call(this), !n && ((e = this.onFinalize) === null || e === void 0 || e.call(this));
    }
  }, t;
}(_t), Na = Kn(function(r) {
  return function() {
    r(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), sr = function(r) {
  Ae(t, r);
  function t() {
    var e = r.call(this) || this;
    return e.closed = !1, e.currentObservers = null, e.observers = [], e.isStopped = !1, e.hasError = !1, e.thrownError = null, e;
  }
  return t.prototype.lift = function(e) {
    var n = new gn(this, this);
    return n.operator = e, n;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new Na();
  }, t.prototype.next = function(e) {
    var n = this;
    yr(function() {
      var i, u;
      if (n._throwIfClosed(), !n.isStopped) {
        n.currentObservers || (n.currentObservers = Array.from(n.observers));
        try {
          for (var c = er(n.currentObservers), v = c.next(); !v.done; v = c.next()) {
            var f = v.value;
            f.next(e);
          }
        } catch (p) {
          i = { error: p };
        } finally {
          try {
            v && !v.done && (u = c.return) && u.call(c);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
    });
  }, t.prototype.error = function(e) {
    var n = this;
    yr(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.hasError = n.isStopped = !0, n.thrownError = e;
        for (var i = n.observers; i.length; )
          i.shift().error(e);
      }
    });
  }, t.prototype.complete = function() {
    var e = this;
    yr(function() {
      if (e._throwIfClosed(), !e.isStopped) {
        e.isStopped = !0;
        for (var n = e.observers; n.length; )
          n.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var e;
      return ((e = this.observers) === null || e === void 0 ? void 0 : e.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(e) {
    return this._throwIfClosed(), r.prototype._trySubscribe.call(this, e);
  }, t.prototype._subscribe = function(e) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(e), this._innerSubscribe(e);
  }, t.prototype._innerSubscribe = function(e) {
    var n = this, i = this, u = i.hasError, c = i.isStopped, v = i.observers;
    return u || c ? Qn : (this.currentObservers = null, v.push(e), new dr(function() {
      n.currentObservers = null, br(v, e);
    }));
  }, t.prototype._checkFinalizedStatuses = function(e) {
    var n = this, i = n.hasError, u = n.thrownError, c = n.isStopped;
    i ? e.error(u) : c && e.complete();
  }, t.prototype.asObservable = function() {
    var e = new ge();
    return e.source = this, e;
  }, t.create = function(e, n) {
    return new gn(e, n);
  }, t;
}(ge), gn = function(r) {
  Ae(t, r);
  function t(e, n) {
    var i = r.call(this) || this;
    return i.destination = e, i.source = n, i;
  }
  return t.prototype.next = function(e) {
    var n, i;
    (i = (n = this.destination) === null || n === void 0 ? void 0 : n.next) === null || i === void 0 || i.call(n, e);
  }, t.prototype.error = function(e) {
    var n, i;
    (i = (n = this.destination) === null || n === void 0 ? void 0 : n.error) === null || i === void 0 || i.call(n, e);
  }, t.prototype.complete = function() {
    var e, n;
    (n = (e = this.destination) === null || e === void 0 ? void 0 : e.complete) === null || n === void 0 || n.call(e);
  }, t.prototype._subscribe = function(e) {
    var n, i;
    return (i = (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(e)) !== null && i !== void 0 ? i : Qn;
  }, t;
}(sr), eo = {
  now: function() {
    return (eo.delegate || Date).now();
  },
  delegate: void 0
}, ja = function(r) {
  Ae(t, r);
  function t(e, n) {
    return r.call(this) || this;
  }
  return t.prototype.schedule = function(e, n) {
    return this;
  }, t;
}(dr), wr = {
  setInterval: function(r, t) {
    for (var e = [], n = 2; n < arguments.length; n++)
      e[n - 2] = arguments[n];
    var i = wr.delegate;
    return i != null && i.setInterval ? i.setInterval.apply(i, tr([r, t], rr(e))) : setInterval.apply(void 0, tr([r, t], rr(e)));
  },
  clearInterval: function(r) {
    var t = wr.delegate;
    return ((t == null ? void 0 : t.clearInterval) || clearInterval)(r);
  },
  delegate: void 0
}, La = function(r) {
  Ae(t, r);
  function t(e, n) {
    var i = r.call(this, e, n) || this;
    return i.scheduler = e, i.work = n, i.pending = !1, i;
  }
  return t.prototype.schedule = function(e, n) {
    var i;
    if (n === void 0 && (n = 0), this.closed)
      return this;
    this.state = e;
    var u = this.id, c = this.scheduler;
    return u != null && (this.id = this.recycleAsyncId(c, u, n)), this.pending = !0, this.delay = n, this.id = (i = this.id) !== null && i !== void 0 ? i : this.requestAsyncId(c, this.id, n), this;
  }, t.prototype.requestAsyncId = function(e, n, i) {
    return i === void 0 && (i = 0), wr.setInterval(e.flush.bind(e, this), i);
  }, t.prototype.recycleAsyncId = function(e, n, i) {
    if (i === void 0 && (i = 0), i != null && this.delay === i && this.pending === !1)
      return n;
    n != null && wr.clearInterval(n);
  }, t.prototype.execute = function(e, n) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var i = this._execute(e, n);
    if (i)
      return i;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(e, n) {
    var i = !1, u;
    try {
      this.work(e);
    } catch (c) {
      i = !0, u = c || new Error("Scheduled action threw falsy error");
    }
    if (i)
      return this.unsubscribe(), u;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var e = this, n = e.id, i = e.scheduler, u = i.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, br(u, this), n != null && (this.id = this.recycleAsyncId(i, n, null)), this.delay = null, r.prototype.unsubscribe.call(this);
    }
  }, t;
}(ja), bn = function() {
  function r(t, e) {
    e === void 0 && (e = r.now), this.schedulerActionCtor = t, this.now = e;
  }
  return r.prototype.schedule = function(t, e, n) {
    return e === void 0 && (e = 0), new this.schedulerActionCtor(this, t).schedule(n, e);
  }, r.now = eo.now, r;
}(), Fa = function(r) {
  Ae(t, r);
  function t(e, n) {
    n === void 0 && (n = bn.now);
    var i = r.call(this, e, n) || this;
    return i.actions = [], i._active = !1, i;
  }
  return t.prototype.flush = function(e) {
    var n = this.actions;
    if (this._active) {
      n.push(e);
      return;
    }
    var i;
    this._active = !0;
    do
      if (i = e.execute(e.state, e.delay))
        break;
    while (e = n.shift());
    if (this._active = !1, i) {
      for (; e = n.shift(); )
        e.unsubscribe();
      throw i;
    }
  }, t;
}(bn), Va = function(r) {
  Ae(t, r);
  function t(e, n) {
    var i = r.call(this, e, n) || this;
    return i.scheduler = e, i.work = n, i;
  }
  return t.prototype.schedule = function(e, n) {
    return n === void 0 && (n = 0), n > 0 ? r.prototype.schedule.call(this, e, n) : (this.delay = n, this.state = e, this.scheduler.flush(this), this);
  }, t.prototype.execute = function(e, n) {
    return n > 0 || this.closed ? r.prototype.execute.call(this, e, n) : this._execute(e, n);
  }, t.prototype.requestAsyncId = function(e, n, i) {
    return i === void 0 && (i = 0), i != null && i > 0 || i == null && this.delay > 0 ? r.prototype.requestAsyncId.call(this, e, n, i) : (e.flush(this), 0);
  }, t;
}(La), Ha = function(r) {
  Ae(t, r);
  function t() {
    return r !== null && r.apply(this, arguments) || this;
  }
  return t;
}(Fa), wn = new Ha(Va), Ya = new ge(function(r) {
  return r.complete();
});
function qa(r) {
  return r && ue(r.schedule);
}
function ro(r) {
  return r[r.length - 1];
}
function Ua(r) {
  return qa(ro(r)) ? r.pop() : void 0;
}
function Ba(r, t) {
  return typeof ro(r) == "number" ? r.pop() : t;
}
var to = function(r) {
  return r && typeof r.length == "number" && typeof r != "function";
};
function no(r) {
  return ue(r == null ? void 0 : r.then);
}
function oo(r) {
  return ue(r[ht]);
}
function io(r) {
  return Symbol.asyncIterator && ue(r == null ? void 0 : r[Symbol.asyncIterator]);
}
function ao(r) {
  return new TypeError("You provided " + (r !== null && typeof r == "object" ? "an invalid object" : "'" + r + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function Wa() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var uo = Wa();
function so(r) {
  return ue(r == null ? void 0 : r[uo]);
}
function co(r) {
  return Aa(this, arguments, function() {
    var e, n, i, u;
    return Xn(this, function(c) {
      switch (c.label) {
        case 0:
          e = r.getReader(), c.label = 1;
        case 1:
          c.trys.push([1, , 9, 10]), c.label = 2;
        case 2:
          return [4, Je(e.read())];
        case 3:
          return n = c.sent(), i = n.value, u = n.done, u ? [4, Je(void 0)] : [3, 5];
        case 4:
          return [2, c.sent()];
        case 5:
          return [4, Je(i)];
        case 6:
          return [4, c.sent()];
        case 7:
          return c.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return e.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function fo(r) {
  return ue(r == null ? void 0 : r.getReader);
}
function nr(r) {
  if (r instanceof ge)
    return r;
  if (r != null) {
    if (oo(r))
      return Ga(r);
    if (to(r))
      return Xa(r);
    if (no(r))
      return Ka(r);
    if (io(r))
      return lo(r);
    if (so(r))
      return Qa(r);
    if (fo(r))
      return Za(r);
  }
  throw ao(r);
}
function Ga(r) {
  return new ge(function(t) {
    var e = r[ht]();
    if (ue(e.subscribe))
      return e.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function Xa(r) {
  return new ge(function(t) {
    for (var e = 0; e < r.length && !t.closed; e++)
      t.next(r[e]);
    t.complete();
  });
}
function Ka(r) {
  return new ge(function(t) {
    r.then(function(e) {
      t.closed || (t.next(e), t.complete());
    }, function(e) {
      return t.error(e);
    }).then(null, zn);
  });
}
function Qa(r) {
  return new ge(function(t) {
    var e, n;
    try {
      for (var i = er(r), u = i.next(); !u.done; u = i.next()) {
        var c = u.value;
        if (t.next(c), t.closed)
          return;
      }
    } catch (v) {
      e = { error: v };
    } finally {
      try {
        u && !u.done && (n = i.return) && n.call(i);
      } finally {
        if (e)
          throw e.error;
      }
    }
    t.complete();
  });
}
function lo(r) {
  return new ge(function(t) {
    Ja(r, t).catch(function(e) {
      return t.error(e);
    });
  });
}
function Za(r) {
  return lo(co(r));
}
function Ja(r, t) {
  var e, n, i, u;
  return Ta(this, void 0, void 0, function() {
    var c, v;
    return Xn(this, function(f) {
      switch (f.label) {
        case 0:
          f.trys.push([0, 5, 6, 11]), e = Pa(r), f.label = 1;
        case 1:
          return [4, e.next()];
        case 2:
          if (n = f.sent(), !!n.done)
            return [3, 4];
          if (c = n.value, t.next(c), t.closed)
            return [2];
          f.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return v = f.sent(), i = { error: v }, [3, 11];
        case 6:
          return f.trys.push([6, , 9, 10]), n && !n.done && (u = e.return) ? [4, u.call(e)] : [3, 8];
        case 7:
          f.sent(), f.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i)
            throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function Le(r, t, e, n, i) {
  n === void 0 && (n = 0), i === void 0 && (i = !1);
  var u = t.schedule(function() {
    e(), i ? r.add(this.schedule(null, n)) : this.unsubscribe();
  }, n);
  if (r.add(u), !i)
    return u;
}
function cr(r, t) {
  return t === void 0 && (t = 0), Ye(function(e, n) {
    e.subscribe(Ve(n, function(i) {
      return Le(n, r, function() {
        return n.next(i);
      }, t);
    }, function() {
      return Le(n, r, function() {
        return n.complete();
      }, t);
    }, function(i) {
      return Le(n, r, function() {
        return n.error(i);
      }, t);
    }));
  });
}
function mt(r, t) {
  return t === void 0 && (t = 0), Ye(function(e, n) {
    n.add(r.schedule(function() {
      return e.subscribe(n);
    }, t));
  });
}
function za(r, t) {
  return nr(r).pipe(mt(t), cr(t));
}
function eu(r, t) {
  return nr(r).pipe(mt(t), cr(t));
}
function ru(r, t) {
  return new ge(function(e) {
    var n = 0;
    return t.schedule(function() {
      n === r.length ? e.complete() : (e.next(r[n++]), e.closed || this.schedule());
    });
  });
}
function tu(r, t) {
  return new ge(function(e) {
    var n;
    return Le(e, t, function() {
      n = r[uo](), Le(e, t, function() {
        var i, u, c;
        try {
          i = n.next(), u = i.value, c = i.done;
        } catch (v) {
          e.error(v);
          return;
        }
        c ? e.complete() : e.next(u);
      }, 0, !0);
    }), function() {
      return ue(n == null ? void 0 : n.return) && n.return();
    };
  });
}
function po(r, t) {
  if (!r)
    throw new Error("Iterable cannot be null");
  return new ge(function(e) {
    Le(e, t, function() {
      var n = r[Symbol.asyncIterator]();
      Le(e, t, function() {
        n.next().then(function(i) {
          i.done ? e.complete() : e.next(i.value);
        });
      }, 0, !0);
    });
  });
}
function nu(r, t) {
  return po(co(r), t);
}
function ou(r, t) {
  if (r != null) {
    if (oo(r))
      return za(r, t);
    if (to(r))
      return ru(r, t);
    if (no(r))
      return eu(r, t);
    if (io(r))
      return po(r, t);
    if (so(r))
      return tu(r, t);
    if (fo(r))
      return nu(r, t);
  }
  throw ao(r);
}
function vo(r, t) {
  return t ? ou(r, t) : nr(r);
}
function gt(r, t) {
  return Ye(function(e, n) {
    var i = 0;
    e.subscribe(Ve(n, function(u) {
      n.next(r.call(t, u, i++));
    }));
  });
}
function iu(r, t, e, n, i, u, c, v) {
  var f = [], p = 0, y = 0, o = !1, a = function() {
    o && !f.length && !p && t.complete();
  }, s = function(h) {
    return p < n ? d(h) : f.push(h);
  }, d = function(h) {
    u && t.next(h), p++;
    var m = !1;
    nr(e(h, y++)).subscribe(Ve(t, function(l) {
      i == null || i(l), u ? s(l) : t.next(l);
    }, function() {
      m = !0;
    }, void 0, function() {
      if (m)
        try {
          p--;
          for (var l = function() {
            var g = f.shift();
            c ? Le(t, c, function() {
              return d(g);
            }) : d(g);
          }; f.length && p < n; )
            l();
          a();
        } catch (g) {
          t.error(g);
        }
    }));
  };
  return r.subscribe(Ve(t, s, function() {
    o = !0, a();
  })), function() {
    v == null || v();
  };
}
function bt(r, t, e) {
  return e === void 0 && (e = 1 / 0), ue(t) ? bt(function(n, i) {
    return gt(function(u, c) {
      return t(n, u, i, c);
    })(nr(r(n, i)));
  }, e) : (typeof t == "number" && (e = t), Ye(function(n, i) {
    return iu(n, i, r, e);
  }));
}
function au(r) {
  return r === void 0 && (r = 1 / 0), bt(yt, r);
}
function uu() {
  for (var r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  var e = Ua(r), n = Ba(r, 1 / 0), i = r;
  return i.length ? i.length === 1 ? nr(i[0]) : au(n)(vo(i, e)) : Ya;
}
function _o(r, t) {
  return Ye(function(e, n) {
    var i = 0;
    e.subscribe(Ve(n, function(u) {
      return r.call(t, u, i++) && n.next(u);
    }));
  });
}
function or() {
  return Ye(function(r, t) {
    r.subscribe(Ve(t, et));
  });
}
function wt() {
  for (var r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  var e = r.length;
  if (e === 0)
    throw new Error("list of properties cannot be empty.");
  return gt(function(n) {
    for (var i = n, u = 0; u < e; u++) {
      var c = i == null ? void 0 : i[r[u]];
      if (typeof c < "u")
        i = c;
      else
        return;
    }
    return i;
  });
}
function He(r, t, e) {
  var n = ue(r) || t || e ? { next: r, error: t, complete: e } : r;
  return n ? Ye(function(i, u) {
    var c;
    (c = n.subscribe) === null || c === void 0 || c.call(n);
    var v = !0;
    i.subscribe(Ve(u, function(f) {
      var p;
      (p = n.next) === null || p === void 0 || p.call(n, f), u.next(f);
    }, function() {
      var f;
      v = !1, (f = n.complete) === null || f === void 0 || f.call(n), u.complete();
    }, function(f) {
      var p;
      v = !1, (p = n.error) === null || p === void 0 || p.call(n, f), u.error(f);
    }, function() {
      var f, p;
      v && ((f = n.unsubscribe) === null || f === void 0 || f.call(n)), (p = n.finalize) === null || p === void 0 || p.call(n);
    }));
  }) : yt;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var tt = function(r, t) {
  return tt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
  }, tt(r, t);
};
function su(r, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  tt(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var cu = (
  /** @class */
  function(r) {
    su(t, r);
    function t(e, n) {
      var i = r.call(this, function(u) {
        var c = i.__notifier.subscribe(u);
        return c && !c.closed && u.next(i.value), c;
      }) || this;
      return i.__notifier = new sr(), i.value = n, e.subscribe(function(u) {
        u !== i.value && (i.value = u, i.__notifier.next(u));
      }), i;
    }
    return t;
  }(ge)
), fu = typeof console == "object" && typeof console.warn == "function" ? function() {
  for (var r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  return console.warn.apply(console, r);
} : function() {
}, Er = function(r) {
  fu("redux-observable | WARNING: " + r);
};
function lu(r) {
  r === void 0 && (r = {});
  var t = wn.constructor, e = new t(wn.schedulerActionCtor);
  if (process.env.NODE_ENV !== "production" && typeof r == "function")
    throw new TypeError("Providing your root Epic to `createEpicMiddleware(rootEpic)` is no longer supported, instead use `epicMiddleware.run(rootEpic)`\n\nLearn more: https://redux-observable.js.org/MIGRATION.html#setting-up-the-middleware");
  var n = new sr(), i, u = function(c) {
    process.env.NODE_ENV !== "production" && i && Er(`this middleware is already associated with a store. createEpicMiddleware should be called for every store.

Learn more: https://goo.gl/2GQ7Da`), i = c;
    var v = new sr(), f = new sr(), p = v.asObservable().pipe(cr(e)), y = new cu(f.pipe(cr(e)), i.getState()), o = n.pipe(gt(function(a) {
      var s = a(p, y, r.dependencies);
      if (!s)
        throw new TypeError('Your root Epic "' + (a.name || "<anonymous>") + `" does not return a stream. Double check you're not missing a return statement!`);
      return s;
    }), bt(function(a) {
      return vo(a).pipe(mt(e), cr(e));
    }));
    return o.subscribe(i.dispatch), function(a) {
      return function(s) {
        var d = a(s);
        return f.next(i.getState()), v.next(s), d;
      };
    };
  };
  return u.run = function(c) {
    process.env.NODE_ENV !== "production" && !i && Er("epicMiddleware.run(rootEpic) called before the middleware has been setup by redux. Provide the epicMiddleware instance to createStore() first."), n.next(c);
  }, u;
}
function du() {
  for (var r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  var e = function() {
    for (var n = [], i = 0; i < arguments.length; i++)
      n[i] = arguments[i];
    return uu.apply(void 0, r.map(function(u) {
      var c = u.apply(void 0, n);
      if (!c)
        throw new TypeError('combineEpics: one of the provided Epics "' + (u.name || "<anonymous>") + `" does not return a stream. Double check you're not missing a return statement!`);
      return c;
    }));
  };
  try {
    Object.defineProperty(e, "name", {
      value: "combineEpics(" + r.map(function(n) {
        return n.name || "<anonymous>";
      }).join(", ") + ")"
    });
  } catch {
  }
  return e;
}
var En = function(r, t) {
  return r === t || typeof t == "function" && r === t.toString();
};
function ir() {
  for (var r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  var e = r.length;
  return process.env.NODE_ENV !== "production" && (e === 0 && Er("ofType was called without any types!"), r.some(function(n) {
    return n == null;
  }) && Er("ofType was called with one or more undefined or null values!")), _o(e === 1 ? function(n) {
    return En(n.type, r[0]);
  } : function(n) {
    for (var i = 0; i < e; i++)
      if (En(n.type, r[i]))
        return !0;
    return !1;
  });
}
function ee(r) {
  return r != null && typeof r == "object" && r["@@functional/placeholder"] === !0;
}
function he(r) {
  return function t(e) {
    return arguments.length === 0 || ee(e) ? t : r.apply(this, arguments);
  };
}
function ve(r) {
  return function t(e, n) {
    switch (arguments.length) {
      case 0:
        return t;
      case 1:
        return ee(e) ? t : he(function(i) {
          return r(e, i);
        });
      default:
        return ee(e) && ee(n) ? t : ee(e) ? he(function(i) {
          return r(i, n);
        }) : ee(n) ? he(function(i) {
          return r(e, i);
        }) : r(e, n);
    }
  };
}
function Et(r, t) {
  switch (r) {
    case 0:
      return function() {
        return t.apply(this, arguments);
      };
    case 1:
      return function(e) {
        return t.apply(this, arguments);
      };
    case 2:
      return function(e, n) {
        return t.apply(this, arguments);
      };
    case 3:
      return function(e, n, i) {
        return t.apply(this, arguments);
      };
    case 4:
      return function(e, n, i, u) {
        return t.apply(this, arguments);
      };
    case 5:
      return function(e, n, i, u, c) {
        return t.apply(this, arguments);
      };
    case 6:
      return function(e, n, i, u, c, v) {
        return t.apply(this, arguments);
      };
    case 7:
      return function(e, n, i, u, c, v, f) {
        return t.apply(this, arguments);
      };
    case 8:
      return function(e, n, i, u, c, v, f, p) {
        return t.apply(this, arguments);
      };
    case 9:
      return function(e, n, i, u, c, v, f, p, y) {
        return t.apply(this, arguments);
      };
    case 10:
      return function(e, n, i, u, c, v, f, p, y, o) {
        return t.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
function ho(r, t, e) {
  return function() {
    for (var n = [], i = 0, u = r, c = 0; c < t.length || i < arguments.length; ) {
      var v;
      c < t.length && (!ee(t[c]) || i >= arguments.length) ? v = t[c] : (v = arguments[i], i += 1), n[c] = v, ee(v) || (u -= 1), c += 1;
    }
    return u <= 0 ? e.apply(this, n) : Et(u, ho(r, n, e));
  };
}
var pu = /* @__PURE__ */ ve(function(t, e) {
  return t === 1 ? he(e) : Et(t, ho(t, [], e));
});
function pr(r) {
  return function t(e, n, i) {
    switch (arguments.length) {
      case 0:
        return t;
      case 1:
        return ee(e) ? t : ve(function(u, c) {
          return r(e, u, c);
        });
      case 2:
        return ee(e) && ee(n) ? t : ee(e) ? ve(function(u, c) {
          return r(u, n, c);
        }) : ee(n) ? ve(function(u, c) {
          return r(e, u, c);
        }) : he(function(u) {
          return r(e, n, u);
        });
      default:
        return ee(e) && ee(n) && ee(i) ? t : ee(e) && ee(n) ? ve(function(u, c) {
          return r(u, c, i);
        }) : ee(e) && ee(i) ? ve(function(u, c) {
          return r(u, n, c);
        }) : ee(n) && ee(i) ? ve(function(u, c) {
          return r(e, u, c);
        }) : ee(e) ? he(function(u) {
          return r(u, n, i);
        }) : ee(n) ? he(function(u) {
          return r(e, u, i);
        }) : ee(i) ? he(function(u) {
          return r(e, n, u);
        }) : r(e, n, i);
    }
  };
}
const St = Array.isArray || function(t) {
  return t != null && t.length >= 0 && Object.prototype.toString.call(t) === "[object Array]";
};
function vu(r) {
  return r != null && typeof r["@@transducer/step"] == "function";
}
function _u(r, t, e) {
  return function() {
    if (arguments.length === 0)
      return e();
    var n = arguments[arguments.length - 1];
    if (!St(n)) {
      for (var i = 0; i < r.length; ) {
        if (typeof n[r[i]] == "function")
          return n[r[i]].apply(n, Array.prototype.slice.call(arguments, 0, -1));
        i += 1;
      }
      if (vu(n)) {
        var u = t.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return u(n);
      }
    }
    return e.apply(this, arguments);
  };
}
const Sn = {
  init: function() {
    return this.xf["@@transducer/init"]();
  },
  result: function(r) {
    return this.xf["@@transducer/result"](r);
  }
};
function hu(r, t) {
  for (var e = 0, n = t.length, i = Array(n); e < n; )
    i[e] = r(t[e]), e += 1;
  return i;
}
function yo(r) {
  return Object.prototype.toString.call(r) === "[object String]";
}
var yu = /* @__PURE__ */ he(function(t) {
  return St(t) ? !0 : !t || typeof t != "object" || yo(t) ? !1 : t.length === 0 ? !0 : t.length > 0 ? t.hasOwnProperty(0) && t.hasOwnProperty(t.length - 1) : !1;
}), mu = /* @__PURE__ */ function() {
  function r(t) {
    this.f = t;
  }
  return r.prototype["@@transducer/init"] = function() {
    throw new Error("init not implemented on XWrap");
  }, r.prototype["@@transducer/result"] = function(t) {
    return t;
  }, r.prototype["@@transducer/step"] = function(t, e) {
    return this.f(t, e);
  }, r;
}();
function gu(r) {
  return new mu(r);
}
var bu = /* @__PURE__ */ ve(function(t, e) {
  return Et(t.length, function() {
    return t.apply(e, arguments);
  });
});
function wu(r, t, e) {
  for (var n = 0, i = e.length; n < i; ) {
    if (t = r["@@transducer/step"](t, e[n]), t && t["@@transducer/reduced"]) {
      t = t["@@transducer/value"];
      break;
    }
    n += 1;
  }
  return r["@@transducer/result"](t);
}
function Tn(r, t, e) {
  for (var n = e.next(); !n.done; ) {
    if (t = r["@@transducer/step"](t, n.value), t && t["@@transducer/reduced"]) {
      t = t["@@transducer/value"];
      break;
    }
    n = e.next();
  }
  return r["@@transducer/result"](t);
}
function An(r, t, e, n) {
  return r["@@transducer/result"](e[n](bu(r["@@transducer/step"], r), t));
}
var Pn = typeof Symbol < "u" ? Symbol.iterator : "@@iterator";
function Eu(r, t, e) {
  if (typeof r == "function" && (r = gu(r)), yu(e))
    return wu(r, t, e);
  if (typeof e["fantasy-land/reduce"] == "function")
    return An(r, t, e, "fantasy-land/reduce");
  if (e[Pn] != null)
    return Tn(r, t, e[Pn]());
  if (typeof e.next == "function")
    return Tn(r, t, e);
  if (typeof e.reduce == "function")
    return An(r, t, e, "reduce");
  throw new TypeError("reduce: list must be array or iterable");
}
var Su = /* @__PURE__ */ function() {
  function r(t, e) {
    this.xf = e, this.f = t;
  }
  return r.prototype["@@transducer/init"] = Sn.init, r.prototype["@@transducer/result"] = Sn.result, r.prototype["@@transducer/step"] = function(t, e) {
    return this.xf["@@transducer/step"](t, this.f(e));
  }, r;
}(), Tu = /* @__PURE__ */ ve(function(t, e) {
  return new Su(t, e);
});
function Sr(r, t) {
  return Object.prototype.hasOwnProperty.call(t, r);
}
var On = Object.prototype.toString, Au = /* @__PURE__ */ function() {
  return On.call(arguments) === "[object Arguments]" ? function(t) {
    return On.call(t) === "[object Arguments]";
  } : function(t) {
    return Sr("callee", t);
  };
}(), Pu = !/* @__PURE__ */ {
  toString: null
}.propertyIsEnumerable("toString"), xn = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"], Rn = /* @__PURE__ */ function() {
  return arguments.propertyIsEnumerable("length");
}(), Ou = function(t, e) {
  for (var n = 0; n < t.length; ) {
    if (t[n] === e)
      return !0;
    n += 1;
  }
  return !1;
}, xu = /* @__PURE__ */ he(typeof Object.keys == "function" && !Rn ? function(t) {
  return Object(t) !== t ? [] : Object.keys(t);
} : function(t) {
  if (Object(t) !== t)
    return [];
  var e, n, i = [], u = Rn && Au(t);
  for (e in t)
    Sr(e, t) && (!u || e !== "length") && (i[i.length] = e);
  if (Pu)
    for (n = xn.length - 1; n >= 0; )
      e = xn[n], Sr(e, t) && !Ou(i, e) && (i[i.length] = e), n -= 1;
  return i;
}), Ru = /* @__PURE__ */ ve(
  /* @__PURE__ */ _u(["fantasy-land/map", "map"], Tu, function(t, e) {
    switch (Object.prototype.toString.call(e)) {
      case "[object Function]":
        return pu(e.length, function() {
          return t.call(this, e.apply(this, arguments));
        });
      case "[object Object]":
        return Eu(function(n, i) {
          return n[i] = t(e[i]), n;
        }, {}, xu(e));
      default:
        return hu(t, e);
    }
  })
);
const Ar = Number.isInteger || function(t) {
  return t << 0 === t;
};
var mo = /* @__PURE__ */ ve(function(t, e) {
  var n = t < 0 ? e.length + t : t;
  return yo(e) ? e.charAt(n) : e[n];
}), go = /* @__PURE__ */ ve(function(t, e) {
  if (e != null)
    return Ar(t) ? mo(t, e) : e[t];
}), Iu = /* @__PURE__ */ he(function(t) {
  return function() {
    return t;
  };
});
function Cu(r, t, e) {
  if (Ar(r) && St(e)) {
    var n = [].concat(e);
    return n[r] = t, n;
  }
  var i = {};
  for (var u in e)
    i[u] = e[u];
  return i[r] = t, i;
}
var ku = /* @__PURE__ */ he(function(t) {
  return t == null;
}), Mu = /* @__PURE__ */ pr(function r(t, e, n) {
  if (t.length === 0)
    return e;
  var i = t[0];
  if (t.length > 1) {
    var u = !ku(n) && Sr(i, n) ? n[i] : Ar(t[1]) ? [] : {};
    e = r(Array.prototype.slice.call(t, 1), e, u);
  }
  return Cu(i, e, n);
}), Du = /* @__PURE__ */ pr(function(t, e, n) {
  return Mu([t], e, n);
}), $u = /* @__PURE__ */ pr(function(t, e, n) {
  if (t > e)
    throw new Error("min must not be greater than max in clamp(min, max, value)");
  return n < t ? t : n > e ? e : n;
});
const Nu = $u;
var ju = /* @__PURE__ */ ve(function(t, e) {
  return function(n) {
    return function(i) {
      return Ru(function(u) {
        return e(u, i);
      }, n(t(i)));
    };
  };
}), Lu = /* @__PURE__ */ ve(function(t, e) {
  return t.map(function(n) {
    for (var i = e, u = 0, c; u < n.length; ) {
      if (i == null)
        return;
      c = n[u], i = Ar(c) ? mo(c, i) : i[c], u += 1;
    }
    return i;
  });
}), Fu = /* @__PURE__ */ ve(function(t, e) {
  return Lu([t], e)[0];
});
const qe = Fu;
var Vu = /* @__PURE__ */ he(function(t) {
  return ju(go(t), Du(t));
});
const Ue = Vu;
var bo = function(r) {
  return {
    value: r,
    map: function(t) {
      return bo(t(r));
    }
  };
}, Hu = /* @__PURE__ */ pr(function(t, e, n) {
  return t(function(i) {
    return bo(e(i));
  })(n).value;
}), Yu = /* @__PURE__ */ pr(function(t, e, n) {
  return Hu(t, Iu(e), n);
});
const Me = Yu;
var qu = function(r, t, e, n, i, u, c, v) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error("invariant requires an error message argument");
  if (!r) {
    var f;
    if (t === void 0)
      f = new Error(
        "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
      );
    else {
      var p = [e, n, i, u, c, v], y = 0;
      f = new Error(
        t.replace(/%s/g, function() {
          return p[y++];
        })
      ), f.name = "Invariant Violation";
    }
    throw f.framesToPop = 1, f;
  }
}, Uu = qu;
const Bu = /* @__PURE__ */ Tr(Uu), In = function(r) {
  return typeof r == "function";
}, Wr = function(r) {
  return r;
}, Cn = function(r) {
  return r === null;
};
function Se(r, t, e) {
  t === void 0 && (t = Wr), Bu(In(t) || Cn(t), "Expected payloadCreator to be a function, undefined or null");
  var n = Cn(t) || t === Wr ? Wr : function(v) {
    for (var f = arguments.length, p = new Array(f > 1 ? f - 1 : 0), y = 1; y < f; y++)
      p[y - 1] = arguments[y];
    return v instanceof Error ? v : t.apply(void 0, [v].concat(p));
  }, i = In(e), u = r.toString(), c = function() {
    var f = n.apply(void 0, arguments), p = {
      type: r
    };
    return f instanceof Error && (p.error = !0), f !== void 0 && (p.payload = f), i && (p.meta = e.apply(void 0, arguments)), p;
  };
  return c.toString = function() {
    return u;
  }, c;
}
const Tt = "PLAY_AUDIO", Wu = Se(Tt), At = (...r) => Te(Wu(...r)), Pt = "PAUSE_AUDIO", Gu = Se(Pt), Ot = (...r) => Te(Gu(...r)), xt = "CHANGE_SRC", Xu = Se(xt, (r, t, e) => ({
  src: r,
  duration: t,
  meta: e
})), nt = (...r) => Te(Xu(...r)), wo = "CHANGE_SEEK", Ku = Se(wo, (r) => ({ newSeek: r })), Rt = (...r) => Te(Ku(...r)), Eo = "SET_DURATION", Qu = Se(Eo, (r) => ({
  duration: r
})), Zu = (...r) => Te(Qu(...r)), So = "SET_META", Ju = Se(So, (r) => ({
  meta: r
})), zu = (...r) => Te(Ju(...r)), To = "SET_VOLUME", es = Se(To, (r) => ({
  volume: r
})), rs = (...r) => Te(es(...r)), Ao = "SET_RATE", ts = Se(Ao, (r) => ({
  rate: r
})), Po = (...r) => Te(ts(...r)), Oo = "EFFECT_SET_AUDIO_ELEMENT", ns = Se(
  Oo,
  (r) => ({ element: r })
), os = (...r) => Te(ns(...r)), xo = "EFFECT_USER_CHANGE_SEEK", is = Se(
  xo,
  (r) => ({ newSeek: r })
), Ro = (...r) => Te(is(...r)), Io = "EFFECT_FINISH_AUDIO", as = Se(Io), It = (...r) => Te(as(...r)), us = {
  src: null,
  playing: !1,
  seek: 0,
  duration: 0,
  volume: 1,
  rate: 1,
  meta: {}
}, kn = Ue("playing"), ss = Ue("src"), cs = Ue("seek"), fs = Ue("duration"), ls = Ue("meta"), ds = Ue("volume"), ps = Ue("rate"), be = () => qe(["src"], Be()), Pr = () => qe(["playing"], Be()), Ct = () => qe(["seek"], Be()), kt = () => qe(["duration"], Be()), vs = () => qe(["volume"], Be()), Or = () => qe(["rate"], Be()), Co = () => qe(["meta"], Be()), Mn = {
  [Tt]: (r) => Me(kn, !0, r),
  [Pt]: (r) => Me(kn, !1, r),
  [xt]: (r, { src: t }) => Me(ss, t, r),
  [wo]: (r, { newSeek: t }) => Me(cs, Number(t) || 0, r),
  [Eo]: (r, { duration: t }) => Me(fs, t, r),
  [So]: (r, { meta: t }) => Me(ls, t, r),
  [To]: (r, { volume: t }) => Me(ds, t, r),
  [Ao]: (r, { rate: t }) => Me(ps, t, r)
}, _s = (r = us, { type: t, payload: e }) => Mn[t] ? Mn[t](r, e) : r, ko = 0.15;
let Mo = null, Mt = null;
const hs = (r) => r.pipe(
  ir(xt),
  wt("payload"),
  He(() => {
    Ot(), Rt(0);
  }),
  _o(go("src")),
  He(({ duration: t, meta: e }) => {
    Zu(t), zu(e), At();
  }),
  or()
), ys = (r) => r.pipe(
  ir(Tt),
  He(() => {
    Mo = setInterval(() => {
      Rt(
        (Mt.seek() / (kt() - ko)).toFixed(3)
      );
    }, 30);
  }),
  or()
), ms = (r) => r.pipe(
  ir(Pt),
  He(() => clearInterval(Mo)),
  or()
), gs = (r) => r.pipe(
  ir(xo),
  wt("payload"),
  He((t) => {
    Mt.seek(t.newSeek * (kt() - ko)), Rt(t.newSeek);
  }),
  or()
), bs = (r) => r.pipe(
  ir(Oo),
  wt("payload"),
  He(({ element: t }) => {
    Mt = t;
  }),
  or()
), ws = (r) => r.pipe(
  ir(Io),
  He(() => nt(null)),
  or()
), Es = du(
  hs,
  ys,
  ms,
  gs,
  bs,
  ws
), Ss = typeof window == "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: "weblite-web-audio"
}) : Gn, Do = lu(), vr = Wn(
  _s,
  Ss(Sa(Do))
);
Do.run(Es);
const Dt = ui(null), je = va(Dt), { getState: Be, dispatch: Te } = vr;
var $t = {}, Gr = {};
/*!
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */
var Dn;
function Ts() {
  return Dn || (Dn = 1, function(r) {
    (function() {
      var t = function() {
        this.init();
      };
      t.prototype = {
        /**
         * Initialize the global Howler object.
         * @return {Howler}
         */
        init: function() {
          var o = this || e;
          return o._counter = 1e3, o._html5AudioPool = [], o.html5PoolSize = 10, o._codecs = {}, o._howls = [], o._muted = !1, o._volume = 1, o._canPlayEvent = "canplaythrough", o._navigator = typeof window < "u" && window.navigator ? window.navigator : null, o.masterGain = null, o.noAudio = !1, o.usingWebAudio = !0, o.autoSuspend = !0, o.ctx = null, o.autoUnlock = !0, o._setup(), o;
        },
        /**
         * Get/set the global volume for all sounds.
         * @param  {Float} vol Volume from 0.0 to 1.0.
         * @return {Howler/Float}     Returns self or current volume.
         */
        volume: function(o) {
          var a = this || e;
          if (o = parseFloat(o), a.ctx || y(), typeof o < "u" && o >= 0 && o <= 1) {
            if (a._volume = o, a._muted)
              return a;
            a.usingWebAudio && a.masterGain.gain.setValueAtTime(o, e.ctx.currentTime);
            for (var s = 0; s < a._howls.length; s++)
              if (!a._howls[s]._webAudio)
                for (var d = a._howls[s]._getSoundIds(), h = 0; h < d.length; h++) {
                  var m = a._howls[s]._soundById(d[h]);
                  m && m._node && (m._node.volume = m._volume * o);
                }
            return a;
          }
          return a._volume;
        },
        /**
         * Handle muting and unmuting globally.
         * @param  {Boolean} muted Is muted or not.
         */
        mute: function(o) {
          var a = this || e;
          a.ctx || y(), a._muted = o, a.usingWebAudio && a.masterGain.gain.setValueAtTime(o ? 0 : a._volume, e.ctx.currentTime);
          for (var s = 0; s < a._howls.length; s++)
            if (!a._howls[s]._webAudio)
              for (var d = a._howls[s]._getSoundIds(), h = 0; h < d.length; h++) {
                var m = a._howls[s]._soundById(d[h]);
                m && m._node && (m._node.muted = o ? !0 : m._muted);
              }
          return a;
        },
        /**
         * Handle stopping all sounds globally.
         */
        stop: function() {
          for (var o = this || e, a = 0; a < o._howls.length; a++)
            o._howls[a].stop();
          return o;
        },
        /**
         * Unload and destroy all currently loaded Howl objects.
         * @return {Howler}
         */
        unload: function() {
          for (var o = this || e, a = o._howls.length - 1; a >= 0; a--)
            o._howls[a].unload();
          return o.usingWebAudio && o.ctx && typeof o.ctx.close < "u" && (o.ctx.close(), o.ctx = null, y()), o;
        },
        /**
         * Check for codec support of specific extension.
         * @param  {String} ext Audio file extention.
         * @return {Boolean}
         */
        codecs: function(o) {
          return (this || e)._codecs[o.replace(/^x-/, "")];
        },
        /**
         * Setup various state values for global tracking.
         * @return {Howler}
         */
        _setup: function() {
          var o = this || e;
          if (o.state = o.ctx && o.ctx.state || "suspended", o._autoSuspend(), !o.usingWebAudio)
            if (typeof Audio < "u")
              try {
                var a = new Audio();
                typeof a.oncanplaythrough > "u" && (o._canPlayEvent = "canplay");
              } catch {
                o.noAudio = !0;
              }
            else
              o.noAudio = !0;
          try {
            var a = new Audio();
            a.muted && (o.noAudio = !0);
          } catch {
          }
          return o.noAudio || o._setupCodecs(), o;
        },
        /**
         * Check for browser support for various codecs and cache the results.
         * @return {Howler}
         */
        _setupCodecs: function() {
          var o = this || e, a = null;
          try {
            a = typeof Audio < "u" ? new Audio() : null;
          } catch {
            return o;
          }
          if (!a || typeof a.canPlayType != "function")
            return o;
          var s = a.canPlayType("audio/mpeg;").replace(/^no$/, ""), d = o._navigator ? o._navigator.userAgent : "", h = d.match(/OPR\/(\d+)/g), m = h && parseInt(h[0].split("/")[1], 10) < 33, l = d.indexOf("Safari") !== -1 && d.indexOf("Chrome") === -1, g = d.match(/Version\/(.*?) /), S = l && g && parseInt(g[1], 10) < 15;
          return o._codecs = {
            mp3: !!(!m && (s || a.canPlayType("audio/mp3;").replace(/^no$/, ""))),
            mpeg: !!s,
            opus: !!a.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
            ogg: !!a.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
            oga: !!a.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
            wav: !!(a.canPlayType('audio/wav; codecs="1"') || a.canPlayType("audio/wav")).replace(/^no$/, ""),
            aac: !!a.canPlayType("audio/aac;").replace(/^no$/, ""),
            caf: !!a.canPlayType("audio/x-caf;").replace(/^no$/, ""),
            m4a: !!(a.canPlayType("audio/x-m4a;") || a.canPlayType("audio/m4a;") || a.canPlayType("audio/aac;")).replace(/^no$/, ""),
            m4b: !!(a.canPlayType("audio/x-m4b;") || a.canPlayType("audio/m4b;") || a.canPlayType("audio/aac;")).replace(/^no$/, ""),
            mp4: !!(a.canPlayType("audio/x-mp4;") || a.canPlayType("audio/mp4;") || a.canPlayType("audio/aac;")).replace(/^no$/, ""),
            weba: !!(!S && a.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
            webm: !!(!S && a.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
            dolby: !!a.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
            flac: !!(a.canPlayType("audio/x-flac;") || a.canPlayType("audio/flac;")).replace(/^no$/, "")
          }, o;
        },
        /**
         * Some browsers/devices will only allow audio to be played after a user interaction.
         * Attempt to automatically unlock audio on the first user interaction.
         * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
         * @return {Howler}
         */
        _unlockAudio: function() {
          var o = this || e;
          if (!(o._audioUnlocked || !o.ctx)) {
            o._audioUnlocked = !1, o.autoUnlock = !1, !o._mobileUnloaded && o.ctx.sampleRate !== 44100 && (o._mobileUnloaded = !0, o.unload()), o._scratchBuffer = o.ctx.createBuffer(1, 1, 22050);
            var a = function(s) {
              for (; o._html5AudioPool.length < o.html5PoolSize; )
                try {
                  var d = new Audio();
                  d._unlocked = !0, o._releaseHtml5Audio(d);
                } catch {
                  o.noAudio = !0;
                  break;
                }
              for (var h = 0; h < o._howls.length; h++)
                if (!o._howls[h]._webAudio)
                  for (var m = o._howls[h]._getSoundIds(), l = 0; l < m.length; l++) {
                    var g = o._howls[h]._soundById(m[l]);
                    g && g._node && !g._node._unlocked && (g._node._unlocked = !0, g._node.load());
                  }
              o._autoResume();
              var S = o.ctx.createBufferSource();
              S.buffer = o._scratchBuffer, S.connect(o.ctx.destination), typeof S.start > "u" ? S.noteOn(0) : S.start(0), typeof o.ctx.resume == "function" && o.ctx.resume(), S.onended = function() {
                S.disconnect(0), o._audioUnlocked = !0, document.removeEventListener("touchstart", a, !0), document.removeEventListener("touchend", a, !0), document.removeEventListener("click", a, !0), document.removeEventListener("keydown", a, !0);
                for (var A = 0; A < o._howls.length; A++)
                  o._howls[A]._emit("unlock");
              };
            };
            return document.addEventListener("touchstart", a, !0), document.addEventListener("touchend", a, !0), document.addEventListener("click", a, !0), document.addEventListener("keydown", a, !0), o;
          }
        },
        /**
         * Get an unlocked HTML5 Audio object from the pool. If none are left,
         * return a new Audio object and throw a warning.
         * @return {Audio} HTML5 Audio object.
         */
        _obtainHtml5Audio: function() {
          var o = this || e;
          if (o._html5AudioPool.length)
            return o._html5AudioPool.pop();
          var a = new Audio().play();
          return a && typeof Promise < "u" && (a instanceof Promise || typeof a.then == "function") && a.catch(function() {
            console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
          }), new Audio();
        },
        /**
         * Return an activated HTML5 Audio object to the pool.
         * @return {Howler}
         */
        _releaseHtml5Audio: function(o) {
          var a = this || e;
          return o._unlocked && a._html5AudioPool.push(o), a;
        },
        /**
         * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
         * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
         * @return {Howler}
         */
        _autoSuspend: function() {
          var o = this;
          if (!(!o.autoSuspend || !o.ctx || typeof o.ctx.suspend > "u" || !e.usingWebAudio)) {
            for (var a = 0; a < o._howls.length; a++)
              if (o._howls[a]._webAudio) {
                for (var s = 0; s < o._howls[a]._sounds.length; s++)
                  if (!o._howls[a]._sounds[s]._paused)
                    return o;
              }
            return o._suspendTimer && clearTimeout(o._suspendTimer), o._suspendTimer = setTimeout(function() {
              if (o.autoSuspend) {
                o._suspendTimer = null, o.state = "suspending";
                var d = function() {
                  o.state = "suspended", o._resumeAfterSuspend && (delete o._resumeAfterSuspend, o._autoResume());
                };
                o.ctx.suspend().then(d, d);
              }
            }, 3e4), o;
          }
        },
        /**
         * Automatically resume the Web Audio AudioContext when a new sound is played.
         * @return {Howler}
         */
        _autoResume: function() {
          var o = this;
          if (!(!o.ctx || typeof o.ctx.resume > "u" || !e.usingWebAudio))
            return o.state === "running" && o.ctx.state !== "interrupted" && o._suspendTimer ? (clearTimeout(o._suspendTimer), o._suspendTimer = null) : o.state === "suspended" || o.state === "running" && o.ctx.state === "interrupted" ? (o.ctx.resume().then(function() {
              o.state = "running";
              for (var a = 0; a < o._howls.length; a++)
                o._howls[a]._emit("resume");
            }), o._suspendTimer && (clearTimeout(o._suspendTimer), o._suspendTimer = null)) : o.state === "suspending" && (o._resumeAfterSuspend = !0), o;
        }
      };
      var e = new t(), n = function(o) {
        var a = this;
        if (!o.src || o.src.length === 0) {
          console.error("An array of source files must be passed with any new Howl.");
          return;
        }
        a.init(o);
      };
      n.prototype = {
        /**
         * Initialize a new Howl group object.
         * @param  {Object} o Passed in properties for this group.
         * @return {Howl}
         */
        init: function(o) {
          var a = this;
          return e.ctx || y(), a._autoplay = o.autoplay || !1, a._format = typeof o.format != "string" ? o.format : [o.format], a._html5 = o.html5 || !1, a._muted = o.mute || !1, a._loop = o.loop || !1, a._pool = o.pool || 5, a._preload = typeof o.preload == "boolean" || o.preload === "metadata" ? o.preload : !0, a._rate = o.rate || 1, a._sprite = o.sprite || {}, a._src = typeof o.src != "string" ? o.src : [o.src], a._volume = o.volume !== void 0 ? o.volume : 1, a._xhr = {
            method: o.xhr && o.xhr.method ? o.xhr.method : "GET",
            headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
            withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : !1
          }, a._duration = 0, a._state = "unloaded", a._sounds = [], a._endTimers = {}, a._queue = [], a._playLock = !1, a._onend = o.onend ? [{ fn: o.onend }] : [], a._onfade = o.onfade ? [{ fn: o.onfade }] : [], a._onload = o.onload ? [{ fn: o.onload }] : [], a._onloaderror = o.onloaderror ? [{ fn: o.onloaderror }] : [], a._onplayerror = o.onplayerror ? [{ fn: o.onplayerror }] : [], a._onpause = o.onpause ? [{ fn: o.onpause }] : [], a._onplay = o.onplay ? [{ fn: o.onplay }] : [], a._onstop = o.onstop ? [{ fn: o.onstop }] : [], a._onmute = o.onmute ? [{ fn: o.onmute }] : [], a._onvolume = o.onvolume ? [{ fn: o.onvolume }] : [], a._onrate = o.onrate ? [{ fn: o.onrate }] : [], a._onseek = o.onseek ? [{ fn: o.onseek }] : [], a._onunlock = o.onunlock ? [{ fn: o.onunlock }] : [], a._onresume = [], a._webAudio = e.usingWebAudio && !a._html5, typeof e.ctx < "u" && e.ctx && e.autoUnlock && e._unlockAudio(), e._howls.push(a), a._autoplay && a._queue.push({
            event: "play",
            action: function() {
              a.play();
            }
          }), a._preload && a._preload !== "none" && a.load(), a;
        },
        /**
         * Load the audio file.
         * @return {Howler}
         */
        load: function() {
          var o = this, a = null;
          if (e.noAudio) {
            o._emit("loaderror", null, "No audio support.");
            return;
          }
          typeof o._src == "string" && (o._src = [o._src]);
          for (var s = 0; s < o._src.length; s++) {
            var d, h;
            if (o._format && o._format[s])
              d = o._format[s];
            else {
              if (h = o._src[s], typeof h != "string") {
                o._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                continue;
              }
              d = /^data:audio\/([^;,]+);/i.exec(h), d || (d = /\.([^.]+)$/.exec(h.split("?", 1)[0])), d && (d = d[1].toLowerCase());
            }
            if (d || console.warn('No file extension was found. Consider using the "format" property or specify an extension.'), d && e.codecs(d)) {
              a = o._src[s];
              break;
            }
          }
          if (!a) {
            o._emit("loaderror", null, "No codec support for selected audio sources.");
            return;
          }
          return o._src = a, o._state = "loading", window.location.protocol === "https:" && a.slice(0, 5) === "http:" && (o._html5 = !0, o._webAudio = !1), new i(o), o._webAudio && c(o), o;
        },
        /**
         * Play a sound or resume previous playback.
         * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
         * @param  {Boolean} internal Internal Use: true prevents event firing.
         * @return {Number}          Sound ID.
         */
        play: function(o, a) {
          var s = this, d = null;
          if (typeof o == "number")
            d = o, o = null;
          else {
            if (typeof o == "string" && s._state === "loaded" && !s._sprite[o])
              return null;
            if (typeof o > "u" && (o = "__default", !s._playLock)) {
              for (var h = 0, m = 0; m < s._sounds.length; m++)
                s._sounds[m]._paused && !s._sounds[m]._ended && (h++, d = s._sounds[m]._id);
              h === 1 ? o = null : d = null;
            }
          }
          var l = d ? s._soundById(d) : s._inactiveSound();
          if (!l)
            return null;
          if (d && !o && (o = l._sprite || "__default"), s._state !== "loaded") {
            l._sprite = o, l._ended = !1;
            var g = l._id;
            return s._queue.push({
              event: "play",
              action: function() {
                s.play(g);
              }
            }), g;
          }
          if (d && !l._paused)
            return a || s._loadQueue("play"), l._id;
          s._webAudio && e._autoResume();
          var S = Math.max(0, l._seek > 0 ? l._seek : s._sprite[o][0] / 1e3), A = Math.max(0, (s._sprite[o][0] + s._sprite[o][1]) / 1e3 - S), w = A * 1e3 / Math.abs(l._rate), X = s._sprite[o][0] / 1e3, q = (s._sprite[o][0] + s._sprite[o][1]) / 1e3;
          l._sprite = o, l._ended = !1;
          var B = function() {
            l._paused = !1, l._seek = S, l._start = X, l._stop = q, l._loop = !!(l._loop || s._sprite[o][2]);
          };
          if (S >= q) {
            s._ended(l);
            return;
          }
          var N = l._node;
          if (s._webAudio) {
            var ce = function() {
              s._playLock = !1, B(), s._refreshBuffer(l);
              var H = l._muted || s._muted ? 0 : l._volume;
              N.gain.setValueAtTime(H, e.ctx.currentTime), l._playStart = e.ctx.currentTime, typeof N.bufferSource.start > "u" ? l._loop ? N.bufferSource.noteGrainOn(0, S, 86400) : N.bufferSource.noteGrainOn(0, S, A) : l._loop ? N.bufferSource.start(0, S, 86400) : N.bufferSource.start(0, S, A), w !== 1 / 0 && (s._endTimers[l._id] = setTimeout(s._ended.bind(s, l), w)), a || setTimeout(function() {
                s._emit("play", l._id), s._loadQueue();
              }, 0);
            };
            e.state === "running" && e.ctx.state !== "interrupted" ? ce() : (s._playLock = !0, s.once("resume", ce), s._clearTimer(l._id));
          } else {
            var se = function() {
              N.currentTime = S, N.muted = l._muted || s._muted || e._muted || N.muted, N.volume = l._volume * e.volume(), N.playbackRate = l._rate;
              try {
                var H = N.play();
                if (H && typeof Promise < "u" && (H instanceof Promise || typeof H.then == "function") ? (s._playLock = !0, B(), H.then(function() {
                  s._playLock = !1, N._unlocked = !0, a ? s._loadQueue() : s._emit("play", l._id);
                }).catch(function() {
                  s._playLock = !1, s._emit("playerror", l._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction."), l._ended = !0, l._paused = !0;
                })) : a || (s._playLock = !1, B(), s._emit("play", l._id)), N.playbackRate = l._rate, N.paused) {
                  s._emit("playerror", l._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                  return;
                }
                o !== "__default" || l._loop ? s._endTimers[l._id] = setTimeout(s._ended.bind(s, l), w) : (s._endTimers[l._id] = function() {
                  s._ended(l), N.removeEventListener("ended", s._endTimers[l._id], !1);
                }, N.addEventListener("ended", s._endTimers[l._id], !1));
              } catch (oe) {
                s._emit("playerror", l._id, oe);
              }
            };
            N.src === "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA" && (N.src = s._src, N.load());
            var le = window && window.ejecta || !N.readyState && e._navigator.isCocoonJS;
            if (N.readyState >= 3 || le)
              se();
            else {
              s._playLock = !0, s._state = "loading";
              var O = function() {
                s._state = "loaded", se(), N.removeEventListener(e._canPlayEvent, O, !1);
              };
              N.addEventListener(e._canPlayEvent, O, !1), s._clearTimer(l._id);
            }
          }
          return l._id;
        },
        /**
         * Pause playback and save current position.
         * @param  {Number} id The sound ID (empty to pause all in group).
         * @return {Howl}
         */
        pause: function(o) {
          var a = this;
          if (a._state !== "loaded" || a._playLock)
            return a._queue.push({
              event: "pause",
              action: function() {
                a.pause(o);
              }
            }), a;
          for (var s = a._getSoundIds(o), d = 0; d < s.length; d++) {
            a._clearTimer(s[d]);
            var h = a._soundById(s[d]);
            if (h && !h._paused && (h._seek = a.seek(s[d]), h._rateSeek = 0, h._paused = !0, a._stopFade(s[d]), h._node))
              if (a._webAudio) {
                if (!h._node.bufferSource)
                  continue;
                typeof h._node.bufferSource.stop > "u" ? h._node.bufferSource.noteOff(0) : h._node.bufferSource.stop(0), a._cleanBuffer(h._node);
              } else
                (!isNaN(h._node.duration) || h._node.duration === 1 / 0) && h._node.pause();
            arguments[1] || a._emit("pause", h ? h._id : null);
          }
          return a;
        },
        /**
         * Stop playback and reset to start.
         * @param  {Number} id The sound ID (empty to stop all in group).
         * @param  {Boolean} internal Internal Use: true prevents event firing.
         * @return {Howl}
         */
        stop: function(o, a) {
          var s = this;
          if (s._state !== "loaded" || s._playLock)
            return s._queue.push({
              event: "stop",
              action: function() {
                s.stop(o);
              }
            }), s;
          for (var d = s._getSoundIds(o), h = 0; h < d.length; h++) {
            s._clearTimer(d[h]);
            var m = s._soundById(d[h]);
            m && (m._seek = m._start || 0, m._rateSeek = 0, m._paused = !0, m._ended = !0, s._stopFade(d[h]), m._node && (s._webAudio ? m._node.bufferSource && (typeof m._node.bufferSource.stop > "u" ? m._node.bufferSource.noteOff(0) : m._node.bufferSource.stop(0), s._cleanBuffer(m._node)) : (!isNaN(m._node.duration) || m._node.duration === 1 / 0) && (m._node.currentTime = m._start || 0, m._node.pause(), m._node.duration === 1 / 0 && s._clearSound(m._node))), a || s._emit("stop", m._id));
          }
          return s;
        },
        /**
         * Mute/unmute a single sound or all sounds in this Howl group.
         * @param  {Boolean} muted Set to true to mute and false to unmute.
         * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
         * @return {Howl}
         */
        mute: function(o, a) {
          var s = this;
          if (s._state !== "loaded" || s._playLock)
            return s._queue.push({
              event: "mute",
              action: function() {
                s.mute(o, a);
              }
            }), s;
          if (typeof a > "u")
            if (typeof o == "boolean")
              s._muted = o;
            else
              return s._muted;
          for (var d = s._getSoundIds(a), h = 0; h < d.length; h++) {
            var m = s._soundById(d[h]);
            m && (m._muted = o, m._interval && s._stopFade(m._id), s._webAudio && m._node ? m._node.gain.setValueAtTime(o ? 0 : m._volume, e.ctx.currentTime) : m._node && (m._node.muted = e._muted ? !0 : o), s._emit("mute", m._id));
          }
          return s;
        },
        /**
         * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
         *   volume() -> Returns the group's volume value.
         *   volume(id) -> Returns the sound id's current volume.
         *   volume(vol) -> Sets the volume of all sounds in this Howl group.
         *   volume(vol, id) -> Sets the volume of passed sound id.
         * @return {Howl/Number} Returns self or current volume.
         */
        volume: function() {
          var o = this, a = arguments, s, d;
          if (a.length === 0)
            return o._volume;
          if (a.length === 1 || a.length === 2 && typeof a[1] > "u") {
            var h = o._getSoundIds(), m = h.indexOf(a[0]);
            m >= 0 ? d = parseInt(a[0], 10) : s = parseFloat(a[0]);
          } else
            a.length >= 2 && (s = parseFloat(a[0]), d = parseInt(a[1], 10));
          var l;
          if (typeof s < "u" && s >= 0 && s <= 1) {
            if (o._state !== "loaded" || o._playLock)
              return o._queue.push({
                event: "volume",
                action: function() {
                  o.volume.apply(o, a);
                }
              }), o;
            typeof d > "u" && (o._volume = s), d = o._getSoundIds(d);
            for (var g = 0; g < d.length; g++)
              l = o._soundById(d[g]), l && (l._volume = s, a[2] || o._stopFade(d[g]), o._webAudio && l._node && !l._muted ? l._node.gain.setValueAtTime(s, e.ctx.currentTime) : l._node && !l._muted && (l._node.volume = s * e.volume()), o._emit("volume", l._id));
          } else
            return l = d ? o._soundById(d) : o._sounds[0], l ? l._volume : 0;
          return o;
        },
        /**
         * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
         * @param  {Number} from The value to fade from (0.0 to 1.0).
         * @param  {Number} to   The volume to fade to (0.0 to 1.0).
         * @param  {Number} len  Time in milliseconds to fade.
         * @param  {Number} id   The sound id (omit to fade all sounds).
         * @return {Howl}
         */
        fade: function(o, a, s, d) {
          var h = this;
          if (h._state !== "loaded" || h._playLock)
            return h._queue.push({
              event: "fade",
              action: function() {
                h.fade(o, a, s, d);
              }
            }), h;
          o = Math.min(Math.max(0, parseFloat(o)), 1), a = Math.min(Math.max(0, parseFloat(a)), 1), s = parseFloat(s), h.volume(o, d);
          for (var m = h._getSoundIds(d), l = 0; l < m.length; l++) {
            var g = h._soundById(m[l]);
            if (g) {
              if (d || h._stopFade(m[l]), h._webAudio && !g._muted) {
                var S = e.ctx.currentTime, A = S + s / 1e3;
                g._volume = o, g._node.gain.setValueAtTime(o, S), g._node.gain.linearRampToValueAtTime(a, A);
              }
              h._startFadeInterval(g, o, a, s, m[l], typeof d > "u");
            }
          }
          return h;
        },
        /**
         * Starts the internal interval to fade a sound.
         * @param  {Object} sound Reference to sound to fade.
         * @param  {Number} from The value to fade from (0.0 to 1.0).
         * @param  {Number} to   The volume to fade to (0.0 to 1.0).
         * @param  {Number} len  Time in milliseconds to fade.
         * @param  {Number} id   The sound id to fade.
         * @param  {Boolean} isGroup   If true, set the volume on the group.
         */
        _startFadeInterval: function(o, a, s, d, h, m) {
          var l = this, g = a, S = s - a, A = Math.abs(S / 0.01), w = Math.max(4, A > 0 ? d / A : d), X = Date.now();
          o._fadeTo = s, o._interval = setInterval(function() {
            var q = (Date.now() - X) / d;
            X = Date.now(), g += S * q, g = Math.round(g * 100) / 100, S < 0 ? g = Math.max(s, g) : g = Math.min(s, g), l._webAudio ? o._volume = g : l.volume(g, o._id, !0), m && (l._volume = g), (s < a && g <= s || s > a && g >= s) && (clearInterval(o._interval), o._interval = null, o._fadeTo = null, l.volume(s, o._id), l._emit("fade", o._id));
          }, w);
        },
        /**
         * Internal method that stops the currently playing fade when
         * a new fade starts, volume is changed or the sound is stopped.
         * @param  {Number} id The sound id.
         * @return {Howl}
         */
        _stopFade: function(o) {
          var a = this, s = a._soundById(o);
          return s && s._interval && (a._webAudio && s._node.gain.cancelScheduledValues(e.ctx.currentTime), clearInterval(s._interval), s._interval = null, a.volume(s._fadeTo, o), s._fadeTo = null, a._emit("fade", o)), a;
        },
        /**
         * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
         *   loop() -> Returns the group's loop value.
         *   loop(id) -> Returns the sound id's loop value.
         *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
         *   loop(loop, id) -> Sets the loop value of passed sound id.
         * @return {Howl/Boolean} Returns self or current loop value.
         */
        loop: function() {
          var o = this, a = arguments, s, d, h;
          if (a.length === 0)
            return o._loop;
          if (a.length === 1)
            if (typeof a[0] == "boolean")
              s = a[0], o._loop = s;
            else
              return h = o._soundById(parseInt(a[0], 10)), h ? h._loop : !1;
          else
            a.length === 2 && (s = a[0], d = parseInt(a[1], 10));
          for (var m = o._getSoundIds(d), l = 0; l < m.length; l++)
            h = o._soundById(m[l]), h && (h._loop = s, o._webAudio && h._node && h._node.bufferSource && (h._node.bufferSource.loop = s, s && (h._node.bufferSource.loopStart = h._start || 0, h._node.bufferSource.loopEnd = h._stop, o.playing(m[l]) && (o.pause(m[l], !0), o.play(m[l], !0)))));
          return o;
        },
        /**
         * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
         *   rate() -> Returns the first sound node's current playback rate.
         *   rate(id) -> Returns the sound id's current playback rate.
         *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
         *   rate(rate, id) -> Sets the playback rate of passed sound id.
         * @return {Howl/Number} Returns self or the current playback rate.
         */
        rate: function() {
          var o = this, a = arguments, s, d;
          if (a.length === 0)
            d = o._sounds[0]._id;
          else if (a.length === 1) {
            var h = o._getSoundIds(), m = h.indexOf(a[0]);
            m >= 0 ? d = parseInt(a[0], 10) : s = parseFloat(a[0]);
          } else
            a.length === 2 && (s = parseFloat(a[0]), d = parseInt(a[1], 10));
          var l;
          if (typeof s == "number") {
            if (o._state !== "loaded" || o._playLock)
              return o._queue.push({
                event: "rate",
                action: function() {
                  o.rate.apply(o, a);
                }
              }), o;
            typeof d > "u" && (o._rate = s), d = o._getSoundIds(d);
            for (var g = 0; g < d.length; g++)
              if (l = o._soundById(d[g]), l) {
                o.playing(d[g]) && (l._rateSeek = o.seek(d[g]), l._playStart = o._webAudio ? e.ctx.currentTime : l._playStart), l._rate = s, o._webAudio && l._node && l._node.bufferSource ? l._node.bufferSource.playbackRate.setValueAtTime(s, e.ctx.currentTime) : l._node && (l._node.playbackRate = s);
                var S = o.seek(d[g]), A = (o._sprite[l._sprite][0] + o._sprite[l._sprite][1]) / 1e3 - S, w = A * 1e3 / Math.abs(l._rate);
                (o._endTimers[d[g]] || !l._paused) && (o._clearTimer(d[g]), o._endTimers[d[g]] = setTimeout(o._ended.bind(o, l), w)), o._emit("rate", l._id);
              }
          } else
            return l = o._soundById(d), l ? l._rate : o._rate;
          return o;
        },
        /**
         * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
         *   seek() -> Returns the first sound node's current seek position.
         *   seek(id) -> Returns the sound id's current seek position.
         *   seek(seek) -> Sets the seek position of the first sound node.
         *   seek(seek, id) -> Sets the seek position of passed sound id.
         * @return {Howl/Number} Returns self or the current seek position.
         */
        seek: function() {
          var o = this, a = arguments, s, d;
          if (a.length === 0)
            o._sounds.length && (d = o._sounds[0]._id);
          else if (a.length === 1) {
            var h = o._getSoundIds(), m = h.indexOf(a[0]);
            m >= 0 ? d = parseInt(a[0], 10) : o._sounds.length && (d = o._sounds[0]._id, s = parseFloat(a[0]));
          } else
            a.length === 2 && (s = parseFloat(a[0]), d = parseInt(a[1], 10));
          if (typeof d > "u")
            return 0;
          if (typeof s == "number" && (o._state !== "loaded" || o._playLock))
            return o._queue.push({
              event: "seek",
              action: function() {
                o.seek.apply(o, a);
              }
            }), o;
          var l = o._soundById(d);
          if (l)
            if (typeof s == "number" && s >= 0) {
              var g = o.playing(d);
              g && o.pause(d, !0), l._seek = s, l._ended = !1, o._clearTimer(d), !o._webAudio && l._node && !isNaN(l._node.duration) && (l._node.currentTime = s);
              var S = function() {
                g && o.play(d, !0), o._emit("seek", d);
              };
              if (g && !o._webAudio) {
                var A = function() {
                  o._playLock ? setTimeout(A, 0) : S();
                };
                setTimeout(A, 0);
              } else
                S();
            } else if (o._webAudio) {
              var w = o.playing(d) ? e.ctx.currentTime - l._playStart : 0, X = l._rateSeek ? l._rateSeek - l._seek : 0;
              return l._seek + (X + w * Math.abs(l._rate));
            } else
              return l._node.currentTime;
          return o;
        },
        /**
         * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
         * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
         * @return {Boolean} True if playing and false if not.
         */
        playing: function(o) {
          var a = this;
          if (typeof o == "number") {
            var s = a._soundById(o);
            return s ? !s._paused : !1;
          }
          for (var d = 0; d < a._sounds.length; d++)
            if (!a._sounds[d]._paused)
              return !0;
          return !1;
        },
        /**
         * Get the duration of this sound. Passing a sound id will return the sprite duration.
         * @param  {Number} id The sound id to check. If none is passed, return full source duration.
         * @return {Number} Audio duration in seconds.
         */
        duration: function(o) {
          var a = this, s = a._duration, d = a._soundById(o);
          return d && (s = a._sprite[d._sprite][1] / 1e3), s;
        },
        /**
         * Returns the current loaded state of this Howl.
         * @return {String} 'unloaded', 'loading', 'loaded'
         */
        state: function() {
          return this._state;
        },
        /**
         * Unload and destroy the current Howl object.
         * This will immediately stop all sound instances attached to this group.
         */
        unload: function() {
          for (var o = this, a = o._sounds, s = 0; s < a.length; s++)
            a[s]._paused || o.stop(a[s]._id), o._webAudio || (o._clearSound(a[s]._node), a[s]._node.removeEventListener("error", a[s]._errorFn, !1), a[s]._node.removeEventListener(e._canPlayEvent, a[s]._loadFn, !1), a[s]._node.removeEventListener("ended", a[s]._endFn, !1), e._releaseHtml5Audio(a[s]._node)), delete a[s]._node, o._clearTimer(a[s]._id);
          var d = e._howls.indexOf(o);
          d >= 0 && e._howls.splice(d, 1);
          var h = !0;
          for (s = 0; s < e._howls.length; s++)
            if (e._howls[s]._src === o._src || o._src.indexOf(e._howls[s]._src) >= 0) {
              h = !1;
              break;
            }
          return u && h && delete u[o._src], e.noAudio = !1, o._state = "unloaded", o._sounds = [], o = null, null;
        },
        /**
         * Listen to a custom event.
         * @param  {String}   event Event name.
         * @param  {Function} fn    Listener to call.
         * @param  {Number}   id    (optional) Only listen to events for this sound.
         * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
         * @return {Howl}
         */
        on: function(o, a, s, d) {
          var h = this, m = h["_on" + o];
          return typeof a == "function" && m.push(d ? { id: s, fn: a, once: d } : { id: s, fn: a }), h;
        },
        /**
         * Remove a custom event. Call without parameters to remove all events.
         * @param  {String}   event Event name.
         * @param  {Function} fn    Listener to remove. Leave empty to remove all.
         * @param  {Number}   id    (optional) Only remove events for this sound.
         * @return {Howl}
         */
        off: function(o, a, s) {
          var d = this, h = d["_on" + o], m = 0;
          if (typeof a == "number" && (s = a, a = null), a || s)
            for (m = 0; m < h.length; m++) {
              var l = s === h[m].id;
              if (a === h[m].fn && l || !a && l) {
                h.splice(m, 1);
                break;
              }
            }
          else if (o)
            d["_on" + o] = [];
          else {
            var g = Object.keys(d);
            for (m = 0; m < g.length; m++)
              g[m].indexOf("_on") === 0 && Array.isArray(d[g[m]]) && (d[g[m]] = []);
          }
          return d;
        },
        /**
         * Listen to a custom event and remove it once fired.
         * @param  {String}   event Event name.
         * @param  {Function} fn    Listener to call.
         * @param  {Number}   id    (optional) Only listen to events for this sound.
         * @return {Howl}
         */
        once: function(o, a, s) {
          var d = this;
          return d.on(o, a, s, 1), d;
        },
        /**
         * Emit all events of a specific type and pass the sound id.
         * @param  {String} event Event name.
         * @param  {Number} id    Sound ID.
         * @param  {Number} msg   Message to go with event.
         * @return {Howl}
         */
        _emit: function(o, a, s) {
          for (var d = this, h = d["_on" + o], m = h.length - 1; m >= 0; m--)
            (!h[m].id || h[m].id === a || o === "load") && (setTimeout((function(l) {
              l.call(this, a, s);
            }).bind(d, h[m].fn), 0), h[m].once && d.off(o, h[m].fn, h[m].id));
          return d._loadQueue(o), d;
        },
        /**
         * Queue of actions initiated before the sound has loaded.
         * These will be called in sequence, with the next only firing
         * after the previous has finished executing (even if async like play).
         * @return {Howl}
         */
        _loadQueue: function(o) {
          var a = this;
          if (a._queue.length > 0) {
            var s = a._queue[0];
            s.event === o && (a._queue.shift(), a._loadQueue()), o || s.action();
          }
          return a;
        },
        /**
         * Fired when playback ends at the end of the duration.
         * @param  {Sound} sound The sound object to work with.
         * @return {Howl}
         */
        _ended: function(o) {
          var a = this, s = o._sprite;
          if (!a._webAudio && o._node && !o._node.paused && !o._node.ended && o._node.currentTime < o._stop)
            return setTimeout(a._ended.bind(a, o), 100), a;
          var d = !!(o._loop || a._sprite[s][2]);
          if (a._emit("end", o._id), !a._webAudio && d && a.stop(o._id, !0).play(o._id), a._webAudio && d) {
            a._emit("play", o._id), o._seek = o._start || 0, o._rateSeek = 0, o._playStart = e.ctx.currentTime;
            var h = (o._stop - o._start) * 1e3 / Math.abs(o._rate);
            a._endTimers[o._id] = setTimeout(a._ended.bind(a, o), h);
          }
          return a._webAudio && !d && (o._paused = !0, o._ended = !0, o._seek = o._start || 0, o._rateSeek = 0, a._clearTimer(o._id), a._cleanBuffer(o._node), e._autoSuspend()), !a._webAudio && !d && a.stop(o._id, !0), a;
        },
        /**
         * Clear the end timer for a sound playback.
         * @param  {Number} id The sound ID.
         * @return {Howl}
         */
        _clearTimer: function(o) {
          var a = this;
          if (a._endTimers[o]) {
            if (typeof a._endTimers[o] != "function")
              clearTimeout(a._endTimers[o]);
            else {
              var s = a._soundById(o);
              s && s._node && s._node.removeEventListener("ended", a._endTimers[o], !1);
            }
            delete a._endTimers[o];
          }
          return a;
        },
        /**
         * Return the sound identified by this ID, or return null.
         * @param  {Number} id Sound ID
         * @return {Object}    Sound object or null.
         */
        _soundById: function(o) {
          for (var a = this, s = 0; s < a._sounds.length; s++)
            if (o === a._sounds[s]._id)
              return a._sounds[s];
          return null;
        },
        /**
         * Return an inactive sound from the pool or create a new one.
         * @return {Sound} Sound playback object.
         */
        _inactiveSound: function() {
          var o = this;
          o._drain();
          for (var a = 0; a < o._sounds.length; a++)
            if (o._sounds[a]._ended)
              return o._sounds[a].reset();
          return new i(o);
        },
        /**
         * Drain excess inactive sounds from the pool.
         */
        _drain: function() {
          var o = this, a = o._pool, s = 0, d = 0;
          if (!(o._sounds.length < a)) {
            for (d = 0; d < o._sounds.length; d++)
              o._sounds[d]._ended && s++;
            for (d = o._sounds.length - 1; d >= 0; d--) {
              if (s <= a)
                return;
              o._sounds[d]._ended && (o._webAudio && o._sounds[d]._node && o._sounds[d]._node.disconnect(0), o._sounds.splice(d, 1), s--);
            }
          }
        },
        /**
         * Get all ID's from the sounds pool.
         * @param  {Number} id Only return one ID if one is passed.
         * @return {Array}    Array of IDs.
         */
        _getSoundIds: function(o) {
          var a = this;
          if (typeof o > "u") {
            for (var s = [], d = 0; d < a._sounds.length; d++)
              s.push(a._sounds[d]._id);
            return s;
          } else
            return [o];
        },
        /**
         * Load the sound back into the buffer source.
         * @param  {Sound} sound The sound object to work with.
         * @return {Howl}
         */
        _refreshBuffer: function(o) {
          var a = this;
          return o._node.bufferSource = e.ctx.createBufferSource(), o._node.bufferSource.buffer = u[a._src], o._panner ? o._node.bufferSource.connect(o._panner) : o._node.bufferSource.connect(o._node), o._node.bufferSource.loop = o._loop, o._loop && (o._node.bufferSource.loopStart = o._start || 0, o._node.bufferSource.loopEnd = o._stop || 0), o._node.bufferSource.playbackRate.setValueAtTime(o._rate, e.ctx.currentTime), a;
        },
        /**
         * Prevent memory leaks by cleaning up the buffer source after playback.
         * @param  {Object} node Sound's audio node containing the buffer source.
         * @return {Howl}
         */
        _cleanBuffer: function(o) {
          var a = this, s = e._navigator && e._navigator.vendor.indexOf("Apple") >= 0;
          if (!o.bufferSource)
            return a;
          if (e._scratchBuffer && o.bufferSource && (o.bufferSource.onended = null, o.bufferSource.disconnect(0), s))
            try {
              o.bufferSource.buffer = e._scratchBuffer;
            } catch {
            }
          return o.bufferSource = null, a;
        },
        /**
         * Set the source to a 0-second silence to stop any downloading (except in IE).
         * @param  {Object} node Audio node to clear.
         */
        _clearSound: function(o) {
          var a = /MSIE |Trident\//.test(e._navigator && e._navigator.userAgent);
          a || (o.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA");
        }
      };
      var i = function(o) {
        this._parent = o, this.init();
      };
      i.prototype = {
        /**
         * Initialize a new Sound object.
         * @return {Sound}
         */
        init: function() {
          var o = this, a = o._parent;
          return o._muted = a._muted, o._loop = a._loop, o._volume = a._volume, o._rate = a._rate, o._seek = 0, o._paused = !0, o._ended = !0, o._sprite = "__default", o._id = ++e._counter, a._sounds.push(o), o.create(), o;
        },
        /**
         * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
         * @return {Sound}
         */
        create: function() {
          var o = this, a = o._parent, s = e._muted || o._muted || o._parent._muted ? 0 : o._volume;
          return a._webAudio ? (o._node = typeof e.ctx.createGain > "u" ? e.ctx.createGainNode() : e.ctx.createGain(), o._node.gain.setValueAtTime(s, e.ctx.currentTime), o._node.paused = !0, o._node.connect(e.masterGain)) : e.noAudio || (o._node = e._obtainHtml5Audio(), o._errorFn = o._errorListener.bind(o), o._node.addEventListener("error", o._errorFn, !1), o._loadFn = o._loadListener.bind(o), o._node.addEventListener(e._canPlayEvent, o._loadFn, !1), o._endFn = o._endListener.bind(o), o._node.addEventListener("ended", o._endFn, !1), o._node.src = a._src, o._node.preload = a._preload === !0 ? "auto" : a._preload, o._node.volume = s * e.volume(), o._node.load()), o;
        },
        /**
         * Reset the parameters of this sound to the original state (for recycle).
         * @return {Sound}
         */
        reset: function() {
          var o = this, a = o._parent;
          return o._muted = a._muted, o._loop = a._loop, o._volume = a._volume, o._rate = a._rate, o._seek = 0, o._rateSeek = 0, o._paused = !0, o._ended = !0, o._sprite = "__default", o._id = ++e._counter, o;
        },
        /**
         * HTML5 Audio error listener callback.
         */
        _errorListener: function() {
          var o = this;
          o._parent._emit("loaderror", o._id, o._node.error ? o._node.error.code : 0), o._node.removeEventListener("error", o._errorFn, !1);
        },
        /**
         * HTML5 Audio canplaythrough listener callback.
         */
        _loadListener: function() {
          var o = this, a = o._parent;
          a._duration = Math.ceil(o._node.duration * 10) / 10, Object.keys(a._sprite).length === 0 && (a._sprite = { __default: [0, a._duration * 1e3] }), a._state !== "loaded" && (a._state = "loaded", a._emit("load"), a._loadQueue()), o._node.removeEventListener(e._canPlayEvent, o._loadFn, !1);
        },
        /**
         * HTML5 Audio ended listener callback.
         */
        _endListener: function() {
          var o = this, a = o._parent;
          a._duration === 1 / 0 && (a._duration = Math.ceil(o._node.duration * 10) / 10, a._sprite.__default[1] === 1 / 0 && (a._sprite.__default[1] = a._duration * 1e3), a._ended(o)), o._node.removeEventListener("ended", o._endFn, !1);
        }
      };
      var u = {}, c = function(o) {
        var a = o._src;
        if (u[a]) {
          o._duration = u[a].duration, p(o);
          return;
        }
        if (/^data:[^;]+;base64,/.test(a)) {
          for (var s = atob(a.split(",")[1]), d = new Uint8Array(s.length), h = 0; h < s.length; ++h)
            d[h] = s.charCodeAt(h);
          f(d.buffer, o);
        } else {
          var m = new XMLHttpRequest();
          m.open(o._xhr.method, a, !0), m.withCredentials = o._xhr.withCredentials, m.responseType = "arraybuffer", o._xhr.headers && Object.keys(o._xhr.headers).forEach(function(l) {
            m.setRequestHeader(l, o._xhr.headers[l]);
          }), m.onload = function() {
            var l = (m.status + "")[0];
            if (l !== "0" && l !== "2" && l !== "3") {
              o._emit("loaderror", null, "Failed loading audio file with status: " + m.status + ".");
              return;
            }
            f(m.response, o);
          }, m.onerror = function() {
            o._webAudio && (o._html5 = !0, o._webAudio = !1, o._sounds = [], delete u[a], o.load());
          }, v(m);
        }
      }, v = function(o) {
        try {
          o.send();
        } catch {
          o.onerror();
        }
      }, f = function(o, a) {
        var s = function() {
          a._emit("loaderror", null, "Decoding audio data failed.");
        }, d = function(h) {
          h && a._sounds.length > 0 ? (u[a._src] = h, p(a, h)) : s();
        };
        typeof Promise < "u" && e.ctx.decodeAudioData.length === 1 ? e.ctx.decodeAudioData(o).then(d).catch(s) : e.ctx.decodeAudioData(o, d, s);
      }, p = function(o, a) {
        a && !o._duration && (o._duration = a.duration), Object.keys(o._sprite).length === 0 && (o._sprite = { __default: [0, o._duration * 1e3] }), o._state !== "loaded" && (o._state = "loaded", o._emit("load"), o._loadQueue());
      }, y = function() {
        if (e.usingWebAudio) {
          try {
            typeof AudioContext < "u" ? e.ctx = new AudioContext() : typeof webkitAudioContext < "u" ? e.ctx = new webkitAudioContext() : e.usingWebAudio = !1;
          } catch {
            e.usingWebAudio = !1;
          }
          e.ctx || (e.usingWebAudio = !1);
          var o = /iP(hone|od|ad)/.test(e._navigator && e._navigator.platform), a = e._navigator && e._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/), s = a ? parseInt(a[1], 10) : null;
          if (o && s && s < 9) {
            var d = /safari/.test(e._navigator && e._navigator.userAgent.toLowerCase());
            e._navigator && !d && (e.usingWebAudio = !1);
          }
          e.usingWebAudio && (e.masterGain = typeof e.ctx.createGain > "u" ? e.ctx.createGainNode() : e.ctx.createGain(), e.masterGain.gain.setValueAtTime(e._muted ? 0 : e._volume, e.ctx.currentTime), e.masterGain.connect(e.ctx.destination)), e._setup();
        }
      };
      r.Howler = e, r.Howl = n, typeof ur < "u" ? (ur.HowlerGlobal = t, ur.Howler = e, ur.Howl = n, ur.Sound = i) : typeof window < "u" && (window.HowlerGlobal = t, window.Howler = e, window.Howl = n, window.Sound = i);
    })();
    /*!
     *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
     *  
     *  howler.js v2.2.4
     *  howlerjs.com
     *
     *  (c) 2013-2020, James Simpson of GoldFire Studios
     *  goldfirestudios.com
     *
     *  MIT License
     */
    (function() {
      HowlerGlobal.prototype._pos = [0, 0, 0], HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0], HowlerGlobal.prototype.stereo = function(e) {
        var n = this;
        if (!n.ctx || !n.ctx.listener)
          return n;
        for (var i = n._howls.length - 1; i >= 0; i--)
          n._howls[i].stereo(e);
        return n;
      }, HowlerGlobal.prototype.pos = function(e, n, i) {
        var u = this;
        if (!u.ctx || !u.ctx.listener)
          return u;
        if (n = typeof n != "number" ? u._pos[1] : n, i = typeof i != "number" ? u._pos[2] : i, typeof e == "number")
          u._pos = [e, n, i], typeof u.ctx.listener.positionX < "u" ? (u.ctx.listener.positionX.setTargetAtTime(u._pos[0], Howler.ctx.currentTime, 0.1), u.ctx.listener.positionY.setTargetAtTime(u._pos[1], Howler.ctx.currentTime, 0.1), u.ctx.listener.positionZ.setTargetAtTime(u._pos[2], Howler.ctx.currentTime, 0.1)) : u.ctx.listener.setPosition(u._pos[0], u._pos[1], u._pos[2]);
        else
          return u._pos;
        return u;
      }, HowlerGlobal.prototype.orientation = function(e, n, i, u, c, v) {
        var f = this;
        if (!f.ctx || !f.ctx.listener)
          return f;
        var p = f._orientation;
        if (n = typeof n != "number" ? p[1] : n, i = typeof i != "number" ? p[2] : i, u = typeof u != "number" ? p[3] : u, c = typeof c != "number" ? p[4] : c, v = typeof v != "number" ? p[5] : v, typeof e == "number")
          f._orientation = [e, n, i, u, c, v], typeof f.ctx.listener.forwardX < "u" ? (f.ctx.listener.forwardX.setTargetAtTime(e, Howler.ctx.currentTime, 0.1), f.ctx.listener.forwardY.setTargetAtTime(n, Howler.ctx.currentTime, 0.1), f.ctx.listener.forwardZ.setTargetAtTime(i, Howler.ctx.currentTime, 0.1), f.ctx.listener.upX.setTargetAtTime(u, Howler.ctx.currentTime, 0.1), f.ctx.listener.upY.setTargetAtTime(c, Howler.ctx.currentTime, 0.1), f.ctx.listener.upZ.setTargetAtTime(v, Howler.ctx.currentTime, 0.1)) : f.ctx.listener.setOrientation(e, n, i, u, c, v);
        else
          return p;
        return f;
      }, Howl.prototype.init = /* @__PURE__ */ function(e) {
        return function(n) {
          var i = this;
          return i._orientation = n.orientation || [1, 0, 0], i._stereo = n.stereo || null, i._pos = n.pos || null, i._pannerAttr = {
            coneInnerAngle: typeof n.coneInnerAngle < "u" ? n.coneInnerAngle : 360,
            coneOuterAngle: typeof n.coneOuterAngle < "u" ? n.coneOuterAngle : 360,
            coneOuterGain: typeof n.coneOuterGain < "u" ? n.coneOuterGain : 0,
            distanceModel: typeof n.distanceModel < "u" ? n.distanceModel : "inverse",
            maxDistance: typeof n.maxDistance < "u" ? n.maxDistance : 1e4,
            panningModel: typeof n.panningModel < "u" ? n.panningModel : "HRTF",
            refDistance: typeof n.refDistance < "u" ? n.refDistance : 1,
            rolloffFactor: typeof n.rolloffFactor < "u" ? n.rolloffFactor : 1
          }, i._onstereo = n.onstereo ? [{ fn: n.onstereo }] : [], i._onpos = n.onpos ? [{ fn: n.onpos }] : [], i._onorientation = n.onorientation ? [{ fn: n.onorientation }] : [], e.call(this, n);
        };
      }(Howl.prototype.init), Howl.prototype.stereo = function(e, n) {
        var i = this;
        if (!i._webAudio)
          return i;
        if (i._state !== "loaded")
          return i._queue.push({
            event: "stereo",
            action: function() {
              i.stereo(e, n);
            }
          }), i;
        var u = typeof Howler.ctx.createStereoPanner > "u" ? "spatial" : "stereo";
        if (typeof n > "u")
          if (typeof e == "number")
            i._stereo = e, i._pos = [e, 0, 0];
          else
            return i._stereo;
        for (var c = i._getSoundIds(n), v = 0; v < c.length; v++) {
          var f = i._soundById(c[v]);
          if (f)
            if (typeof e == "number")
              f._stereo = e, f._pos = [e, 0, 0], f._node && (f._pannerAttr.panningModel = "equalpower", (!f._panner || !f._panner.pan) && t(f, u), u === "spatial" ? typeof f._panner.positionX < "u" ? (f._panner.positionX.setValueAtTime(e, Howler.ctx.currentTime), f._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime), f._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime)) : f._panner.setPosition(e, 0, 0) : f._panner.pan.setValueAtTime(e, Howler.ctx.currentTime)), i._emit("stereo", f._id);
            else
              return f._stereo;
        }
        return i;
      }, Howl.prototype.pos = function(e, n, i, u) {
        var c = this;
        if (!c._webAudio)
          return c;
        if (c._state !== "loaded")
          return c._queue.push({
            event: "pos",
            action: function() {
              c.pos(e, n, i, u);
            }
          }), c;
        if (n = typeof n != "number" ? 0 : n, i = typeof i != "number" ? -0.5 : i, typeof u > "u")
          if (typeof e == "number")
            c._pos = [e, n, i];
          else
            return c._pos;
        for (var v = c._getSoundIds(u), f = 0; f < v.length; f++) {
          var p = c._soundById(v[f]);
          if (p)
            if (typeof e == "number")
              p._pos = [e, n, i], p._node && ((!p._panner || p._panner.pan) && t(p, "spatial"), typeof p._panner.positionX < "u" ? (p._panner.positionX.setValueAtTime(e, Howler.ctx.currentTime), p._panner.positionY.setValueAtTime(n, Howler.ctx.currentTime), p._panner.positionZ.setValueAtTime(i, Howler.ctx.currentTime)) : p._panner.setPosition(e, n, i)), c._emit("pos", p._id);
            else
              return p._pos;
        }
        return c;
      }, Howl.prototype.orientation = function(e, n, i, u) {
        var c = this;
        if (!c._webAudio)
          return c;
        if (c._state !== "loaded")
          return c._queue.push({
            event: "orientation",
            action: function() {
              c.orientation(e, n, i, u);
            }
          }), c;
        if (n = typeof n != "number" ? c._orientation[1] : n, i = typeof i != "number" ? c._orientation[2] : i, typeof u > "u")
          if (typeof e == "number")
            c._orientation = [e, n, i];
          else
            return c._orientation;
        for (var v = c._getSoundIds(u), f = 0; f < v.length; f++) {
          var p = c._soundById(v[f]);
          if (p)
            if (typeof e == "number")
              p._orientation = [e, n, i], p._node && (p._panner || (p._pos || (p._pos = c._pos || [0, 0, -0.5]), t(p, "spatial")), typeof p._panner.orientationX < "u" ? (p._panner.orientationX.setValueAtTime(e, Howler.ctx.currentTime), p._panner.orientationY.setValueAtTime(n, Howler.ctx.currentTime), p._panner.orientationZ.setValueAtTime(i, Howler.ctx.currentTime)) : p._panner.setOrientation(e, n, i)), c._emit("orientation", p._id);
            else
              return p._orientation;
        }
        return c;
      }, Howl.prototype.pannerAttr = function() {
        var e = this, n = arguments, i, u, c;
        if (!e._webAudio)
          return e;
        if (n.length === 0)
          return e._pannerAttr;
        if (n.length === 1)
          if (typeof n[0] == "object")
            i = n[0], typeof u > "u" && (i.pannerAttr || (i.pannerAttr = {
              coneInnerAngle: i.coneInnerAngle,
              coneOuterAngle: i.coneOuterAngle,
              coneOuterGain: i.coneOuterGain,
              distanceModel: i.distanceModel,
              maxDistance: i.maxDistance,
              refDistance: i.refDistance,
              rolloffFactor: i.rolloffFactor,
              panningModel: i.panningModel
            }), e._pannerAttr = {
              coneInnerAngle: typeof i.pannerAttr.coneInnerAngle < "u" ? i.pannerAttr.coneInnerAngle : e._coneInnerAngle,
              coneOuterAngle: typeof i.pannerAttr.coneOuterAngle < "u" ? i.pannerAttr.coneOuterAngle : e._coneOuterAngle,
              coneOuterGain: typeof i.pannerAttr.coneOuterGain < "u" ? i.pannerAttr.coneOuterGain : e._coneOuterGain,
              distanceModel: typeof i.pannerAttr.distanceModel < "u" ? i.pannerAttr.distanceModel : e._distanceModel,
              maxDistance: typeof i.pannerAttr.maxDistance < "u" ? i.pannerAttr.maxDistance : e._maxDistance,
              refDistance: typeof i.pannerAttr.refDistance < "u" ? i.pannerAttr.refDistance : e._refDistance,
              rolloffFactor: typeof i.pannerAttr.rolloffFactor < "u" ? i.pannerAttr.rolloffFactor : e._rolloffFactor,
              panningModel: typeof i.pannerAttr.panningModel < "u" ? i.pannerAttr.panningModel : e._panningModel
            });
          else
            return c = e._soundById(parseInt(n[0], 10)), c ? c._pannerAttr : e._pannerAttr;
        else
          n.length === 2 && (i = n[0], u = parseInt(n[1], 10));
        for (var v = e._getSoundIds(u), f = 0; f < v.length; f++)
          if (c = e._soundById(v[f]), c) {
            var p = c._pannerAttr;
            p = {
              coneInnerAngle: typeof i.coneInnerAngle < "u" ? i.coneInnerAngle : p.coneInnerAngle,
              coneOuterAngle: typeof i.coneOuterAngle < "u" ? i.coneOuterAngle : p.coneOuterAngle,
              coneOuterGain: typeof i.coneOuterGain < "u" ? i.coneOuterGain : p.coneOuterGain,
              distanceModel: typeof i.distanceModel < "u" ? i.distanceModel : p.distanceModel,
              maxDistance: typeof i.maxDistance < "u" ? i.maxDistance : p.maxDistance,
              refDistance: typeof i.refDistance < "u" ? i.refDistance : p.refDistance,
              rolloffFactor: typeof i.rolloffFactor < "u" ? i.rolloffFactor : p.rolloffFactor,
              panningModel: typeof i.panningModel < "u" ? i.panningModel : p.panningModel
            };
            var y = c._panner;
            y || (c._pos || (c._pos = e._pos || [0, 0, -0.5]), t(c, "spatial"), y = c._panner), y.coneInnerAngle = p.coneInnerAngle, y.coneOuterAngle = p.coneOuterAngle, y.coneOuterGain = p.coneOuterGain, y.distanceModel = p.distanceModel, y.maxDistance = p.maxDistance, y.refDistance = p.refDistance, y.rolloffFactor = p.rolloffFactor, y.panningModel = p.panningModel;
          }
        return e;
      }, Sound.prototype.init = /* @__PURE__ */ function(e) {
        return function() {
          var n = this, i = n._parent;
          n._orientation = i._orientation, n._stereo = i._stereo, n._pos = i._pos, n._pannerAttr = i._pannerAttr, e.call(this), n._stereo ? i.stereo(n._stereo) : n._pos && i.pos(n._pos[0], n._pos[1], n._pos[2], n._id);
        };
      }(Sound.prototype.init), Sound.prototype.reset = /* @__PURE__ */ function(e) {
        return function() {
          var n = this, i = n._parent;
          return n._orientation = i._orientation, n._stereo = i._stereo, n._pos = i._pos, n._pannerAttr = i._pannerAttr, n._stereo ? i.stereo(n._stereo) : n._pos ? i.pos(n._pos[0], n._pos[1], n._pos[2], n._id) : n._panner && (n._panner.disconnect(0), n._panner = void 0, i._refreshBuffer(n)), e.call(this);
        };
      }(Sound.prototype.reset);
      var t = function(e, n) {
        n = n || "spatial", n === "spatial" ? (e._panner = Howler.ctx.createPanner(), e._panner.coneInnerAngle = e._pannerAttr.coneInnerAngle, e._panner.coneOuterAngle = e._pannerAttr.coneOuterAngle, e._panner.coneOuterGain = e._pannerAttr.coneOuterGain, e._panner.distanceModel = e._pannerAttr.distanceModel, e._panner.maxDistance = e._pannerAttr.maxDistance, e._panner.refDistance = e._pannerAttr.refDistance, e._panner.rolloffFactor = e._pannerAttr.rolloffFactor, e._panner.panningModel = e._pannerAttr.panningModel, typeof e._panner.positionX < "u" ? (e._panner.positionX.setValueAtTime(e._pos[0], Howler.ctx.currentTime), e._panner.positionY.setValueAtTime(e._pos[1], Howler.ctx.currentTime), e._panner.positionZ.setValueAtTime(e._pos[2], Howler.ctx.currentTime)) : e._panner.setPosition(e._pos[0], e._pos[1], e._pos[2]), typeof e._panner.orientationX < "u" ? (e._panner.orientationX.setValueAtTime(e._orientation[0], Howler.ctx.currentTime), e._panner.orientationY.setValueAtTime(e._orientation[1], Howler.ctx.currentTime), e._panner.orientationZ.setValueAtTime(e._orientation[2], Howler.ctx.currentTime)) : e._panner.setOrientation(e._orientation[0], e._orientation[1], e._orientation[2])) : (e._panner = Howler.ctx.createStereoPanner(), e._panner.pan.setValueAtTime(e._stereo, Howler.ctx.currentTime)), e._panner.connect(e._node), e._paused || e._parent.pause(e._id, !0).play(e._id, !0);
      };
    })();
  }(Gr)), Gr;
}
var $o = void 0;
typeof window < "u" && ($o = Ts());
var As = $o, Nt = {};
Object.defineProperty(Nt, "__esModule", {
  value: !0
});
Nt.noop = function() {
};
Object.defineProperty($t, "__esModule", {
  value: !0
});
var Ps = /* @__PURE__ */ function() {
  function r(t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, e, n) {
    return e && r(t.prototype, e), n && r(t, n), t;
  };
}(), No = me, Os = jo(No), xs = Fn, re = jo(xs), $n = As, De = Nt;
function jo(r) {
  return r && r.__esModule ? r : { default: r };
}
function Rs(r, t) {
  if (!(r instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Is(r, t) {
  if (!r)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : r;
}
function Cs(r, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  r.prototype = Object.create(t && t.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(r, t) : r.__proto__ = t);
}
var jt = function(r) {
  Cs(t, r);
  function t(e) {
    Rs(this, t);
    var n = Is(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
    return n.initHowler = n.initHowler.bind(n), n;
  }
  return Ps(t, [{
    key: "componentDidMount",
    value: function() {
      this.initHowler();
    }
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      JSON.stringify(n.src) !== JSON.stringify(this.props.src) ? this.initHowler(this.props) : this.toggleHowler(n);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyHowler();
    }
    /**
     * Create howler object with given props
     */
  }, {
    key: "initHowler",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      this.destroyHowler(), typeof $n.Howl < "u" && (this.howler = new $n.Howl({
        src: n.src,
        xhr: n.xhr,
        format: n.format,
        mute: n.mute,
        loop: n.loop,
        preload: n.preload,
        rate: n.rate,
        volume: n.volume,
        onend: n.onEnd,
        onplay: n.onPlay,
        onpause: n.onPause,
        onvolume: n.onVolume,
        onstop: n.onStop,
        onrate: n.onRate,
        onload: n.onLoad,
        onloaderror: n.onLoadError,
        html5: n.html5
      }), n.playing && this.play());
    }
    /**
     * Stop, unload and destroy howler object
     */
  }, {
    key: "destroyHowler",
    value: function() {
      this.howler && (this.howler.off(), this.howler.stop(), this.howler.unload(), this.howler = null);
    }
  }, {
    key: "toggleHowler",
    value: function(n) {
      this.props.playing ? this.play() : this.pause(), this.loop(this.props.loop), n.mute !== this.props.mute && this.mute(this.props.mute), n.volume !== this.props.volume && this.volume(this.props.volume), n.rate !== this.props.rate && this.rate(this.props.rate), this.props.preload && this.howlerState() === "unloaded" && this.load();
    }
  }, {
    key: "play",
    /**
     * Begins playback of a sound when not playing
     */
    value: function() {
      var n = this.howler.playing();
      n || (this.howlerState() === "unloaded" && this.load(), this.howler.play());
    }
    /**
     * Pauses playback of sound or group
     * If no id given, pauses all playback
     * @param {Number} id = undefined [sound of group to pause]
     */
  }, {
    key: "pause",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      n ? this.howler.pause(n) : this.howler.pause();
    }
    /**
     * Check the load status of the Howl
     * @return {String} [unloaded, loading or loaded]
     */
  }, {
    key: "howlerState",
    value: function() {
      return this.howler.state();
    }
    /**
     * Stops playback of sound or group
     * If no id given, stops all playback
     * @param {Number} id = undefined [sound of group to pause]
     */
  }, {
    key: "stop",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      n ? this.howler.stop(n) : this.howler.stop();
    }
    /**
     * Mutes the sound, but doesn't pause the playback.
     * @param {Boolean} [muted] [True to mute and false to unmute]
     * @param {Number} [id] [The sound ID. If none is passed, all sounds in group are muted]
     */
  }, {
    key: "mute",
    value: function() {
      var n;
      (n = this.howler).mute.apply(n, arguments);
    }
    /**
     * Get/set volume of this sound or the group. This method optionally takes 0, 1 or 2 arguments.
     * @param {Number} [volume] [Volume from 0.0 to 1.0]
     * @param {Number} [id] [The sound ID. If none is passed, all sounds in group are muted]
     */
  }, {
    key: "volume",
    value: function() {
      var n;
      return (n = this.howler).volume.apply(n, arguments);
    }
    /**
     * Get/set whether to loop the sound or group. This method can optionally take 0, 1 or 2 arguments.
     * @param {Boolean} [loop] [To loop or not to loop, that is the question]
     * @param {Number} [id] [The sound ID. If none is passed, all sounds in group will have their loop property updated]
     */
  }, {
    key: "loop",
    value: function() {
      var n;
      return (n = this.howler).loop.apply(n, arguments);
    }
    /**
     * Set/get current position of player
     * @param  {Number} pos [seek player to position]
     * @return {Number}     [return current position]
     */
  }, {
    key: "seek",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      if (!this.howler)
        return 0;
      if (!n && n !== 0)
        return this.howler.seek();
      if (n || n === 0)
        return this.howler.seek(n), n;
    }
    /**
     * Get/set the rate of playback for a sound. This method optionally takes 0, 1 or 2 arguments.
     * @param {Number} [rate] - The rate of playback. 0.5 to 4.0, with 1.0 being normal speed.
     * @param {Number} [id] - The sound ID. If none is passed, playback rate of all sounds in group will change.
     */
  }, {
    key: "rate",
    value: function() {
      var n;
      (n = this.howler).rate.apply(n, arguments);
    }
    /**
     * Get the duration of the audio source
     * @return {Number} [Audio length in seconds. Will return 0 until after the load event fires]
     */
  }, {
    key: "duration",
    value: function() {
      return this.howler.duration();
    }
    /**
     * load audio file
     */
  }, {
    key: "load",
    value: function() {
      this.howler.load();
    }
    /**
     * Only render a placeholder
     */
  }, {
    key: "render",
    value: function() {
      return Os.default.createElement("div", null);
    }
  }, {
    key: "howler",
    set: function(n) {
      n && (this._howler = n);
    },
    get: function() {
      return this._howler;
    }
  }]), t;
}(No.Component);
jt.propTypes = {
  src: re.default.oneOfType([re.default.string, re.default.arrayOf(re.default.string)]).isRequired,
  format: re.default.arrayOf(re.default.string),
  xhr: re.default.object,
  playing: re.default.bool,
  mute: re.default.bool,
  loop: re.default.bool,
  preload: re.default.bool,
  rate: re.default.number,
  volume: re.default.number,
  onEnd: re.default.func,
  onPause: re.default.func,
  onPlay: re.default.func,
  onVolume: re.default.func,
  onStop: re.default.func,
  onRate: re.default.func,
  onLoad: re.default.func,
  onLoadError: re.default.func,
  html5: re.default.bool
};
jt.defaultProps = {
  playing: !0,
  // Enable autoplay by default
  format: [],
  xhr: {},
  mute: !1,
  preload: !0,
  loop: !1,
  rate: 1,
  volume: 1,
  onEnd: De.noop,
  onPause: De.noop,
  onPlay: De.noop,
  onVolume: De.noop,
  onStop: De.noop,
  onRate: De.noop,
  onLoad: De.noop,
  onLoadError: De.noop,
  html5: !1
};
$t.default = jt;
var ks = $t.default;
const Ms = /* @__PURE__ */ Tr(ks), Lo = ({
  setAudioElement: r,
  src: t,
  rate: e,
  finishAudio: n,
  isPlaying: i,
  volume: u
}) => {
  const c = me.createRef();
  return me.useEffect(() => {
    r(c.current);
  }, [r]), /* @__PURE__ */ Ce.jsx(
    Ms,
    {
      src: [t],
      ref: c,
      html5: !0,
      playing: i,
      onEnd: n,
      rate: e,
      volume: u
    }
  );
};
Lo.propTypes = {
  src: we.string.isRequired,
  finishAudio: we.func.isRequired,
  isPlaying: we.bool.isRequired,
  rate: we.number.isRequired,
  setAudioElement: we.func.isRequired,
  volume: we.number.isRequired
};
let ot = null;
const Js = (r) => {
  ot = r;
};
function Ds(r) {
  const t = je(() => be() === r ? Ct() : 0), e = si((n) => Ho(r, n), [
    r
  ]);
  return [t, e];
}
function $s(r) {
  const t = je(be), e = je(Pr);
  return r !== t ? "NOT_PLAYING" : e ? "PLAYING" : "PAUSED";
}
function zs() {
  const r = je(be), t = je(kt), e = je(Or), n = je(Co), [i, u] = Ds(r), c = $s(r);
  return {
    seekValue: i,
    setSeekValue: u,
    duration: t,
    rate: e,
    meta: n,
    state: c,
    resume: () => Fo(r),
    pause: () => Vo(r),
    stop: () => Ns(r),
    setRate: (v) => Po(v)
  };
}
function ec() {
  return { showAudioPlayer: !!je(be) };
}
const Fo = (r, t, e) => {
  r === be() ? At() : t ? nt(r, t, e) : nt(r);
}, Vo = (r) => r === be() && Ot(), Ns = (r) => r === be() && It(), Ho = (r, t) => r === be() && Ro(t), rc = (r, t) => r === be() && t <= 1 && t >= 0 && rs(t), js = () => {
  ot ? ot() : It();
}, Ls = () => {
  var r;
  return {
    src: be() || "",
    isPlaying: Pr(),
    volume: vs(),
    rate: ((r = Co()) == null ? void 0 : r.type) === "VOICE" ? Or() : 1
  };
}, Fs = () => ({
  setAudioElement: os,
  finishAudio: js
}), Yo = vt(Ls, Fs, null, {
  context: Dt
})(Lo), Vs = () => null, Hs = (r, t) => Math.floor((1 - Nu(0, 1, t)) * r), Nn = (r) => r && be() === r && Ct() || 0, Ys = (r, { src: t, duration: e }) => ({
  seek: Nn(t),
  playing: t && be() === t ? Pr() : !1,
  remainingTime: Hs(e || 0, Nn(t))
}), qs = (r, { src: t, duration: e }) => ({
  onPlay: () => {
    Fo(t, e);
  },
  onPause: () => {
    Vo(t);
  },
  onChangeSeek: (n) => {
    Ho(t, n);
  }
}), Us = vt(Ys, qs)(Vs), it = 1, Bs = 1.8, Ws = () => null, Gs = () => ({
  seek: Ct(),
  playing: Pr(),
  isOpen: !!be(),
  is2x: Or() !== it
}), Xs = () => ({
  onPlay: () => {
    At();
  },
  onPause: () => {
    Ot();
  },
  onChangeSeek: (r) => {
    Ro(r);
  },
  onFinish: () => {
    It();
  },
  toggle2x: () => {
    const r = it !== Or(), t = r ? it : Bs;
    analite("VOICE_PLAYER", { a: "X", s: r ? "A" : "D" }), Po(t);
  }
}), Ks = vt(Gs, Xs)(Ws), tc = (r) => /* @__PURE__ */ Ce.jsx(lr, { store: vr, children: /* @__PURE__ */ Ce.jsx(Yo, { ...r }) }), nc = (r) => /* @__PURE__ */ Ce.jsx(lr, { store: vr, children: /* @__PURE__ */ Ce.jsx(Us, { ...r }) }), oc = (r) => /* @__PURE__ */ Ce.jsx(lr, { store: vr, children: /* @__PURE__ */ Ce.jsx(Ks, { ...r }) });
function ic({
  children: r
}) {
  return /* @__PURE__ */ Ce.jsxs(lr, { context: Dt, store: vr, children: [
    /* @__PURE__ */ Ce.jsx(Yo, {}),
    r
  ] });
}
export {
  ic as AudioProvider,
  tc as DaemonPlayer,
  nc as InlinePlayer,
  oc as MainPlayer,
  It as dispatchFinishAudio,
  ot as onFinishCustomCallback,
  Vo as pauseAudio,
  Fo as playAudio,
  Ho as setAudioSeek,
  rc as setAudioVolume,
  Js as setOnFinishAudioCallback,
  Ns as stopAudio,
  zs as useAudioPlayerStatus,
  $s as useAudioState,
  Ds as useSeekValue,
  ec as useShowAudioPlayer
};
//# sourceMappingURL=weblite-audio.js.map
